<template>
  <div v-if="loaded" id="intakeView">
    <div id="mobile-menu">
      <img
        v-if="intakeAdmin.beleggen.brand=='VMVB'"
        class="logo vm" src="../assets/vm/VM-logo1.svg"
      />
      <img
        v-if="intakeAdmin.beleggen.brand=='OXBY'"
        class="logo oxby" src="../assets/ox/OX-logo2.svg"
      />
      <img
        v-if="intakeAdmin.beleggen.brand=='BVS'"
        class="logo bvs" src="../assets/bvs/BVS-logo2.svg"
      />
      <img
        v-if="intakeAdmin.beleggen.brand=='Doelbeleggen'"
        class="logo bvs" src="../assets/db/DB-logo2.svg"
      />
      <button
        @click="redo && status === 'Bezig' ? sendProfile() : quitIntake()"
      >
        <awesomeIcon icon="sign-out-alt" flip="horizontal"/>
        {{ redo ? 'Verlaat klantprofiel' : 'Verlaat vragenlijst' }}
      </button>
    </div>

    <sidebar side="left">
      <ul>
        <li class="button" @click="help = true">
          <awesomeIcon icon="question-circle"/> Contact opnemen
        </li>
        <li
          class="button quitButton"
          @click="redo && status === 'Bezig' ? sendProfile() : quitIntake()"
        >
          <awesomeIcon icon="sign-out-alt" flip="horizontal"/>
          {{ redo ? 'Verlaat klantprofiel' : 'Verlaat vragenlijst' }}
        </li>
      </ul>
    </sidebar>

    <contactForm v-if="help" @close="help = false" :intake="Number(id)" />
    <div
      v-if="status === 'Bezig' && role > 7"
      :class="['msg', 'printhide', 'hide-mobile', 'icon', writeModus ? 'valid' : 'error']"
    >
      <div class="icon">
        <awesomeIcon icon="info-circle"/>
      </div>
      <div style="float:left; max-width: calc(100% - 185px);">
        U zit in <b>{{writeModus ? 'schrijfmodus' : 'leesmodus'}}</b>.
        {{writeModus ? `Houd er rekening mee dat u gegevens kan overschrijven die de klant op dit
        moment aan het invullen is. Ga daarom snel uit de intake of schrijfmodus wanneer u klaar
        bent` : `Om te kunnen 'schrijven klik op de knop 'naar schrijfmodus'`}}.
      </div>
      <button @click="writeModus = !writeModus" style="float:right">
        {{ writeModus ? 'Terug naar leesmodus' : 'Naar schrijfmodus' }}
      </button>
    </div>

    <div
      v-if="status != 'Bezig' && status != 'Ingeleverd'"
      class="msg printhide" style="text-align:center;"
    >
      <strong>Status {{status}}</strong>
      Wijzigingen in deze vragenlijst kunnen niet meer worden opgeslagen<br>
      (dit kan alleen wanneer deze status Bezig of Ingeleverd heeft).
      <button v-if="status == 'Afgerond'" @click="redoIntake()" style="float:right;">
        Start her-intake <awesomeIcon icon="angle-right"/>
      </button>
    </div>

    <div class="row steps" v-if="!redo">
      <div class="step sm-col-2 lg-col-2" :class="{'active': !intake.started}">
        <awesomeIcon
          v-if="
            intake.started
            || status === 'Ingeleverd'
            || status === 'Geaccepteerd'
            || status === 'Ondertekend'
          "
          icon="check"
          color="green"
        />
        Doel
      </div>
      <div class="step sm-col-2 lg-col-2" :class="{'active': status == 'Bezig' && intake.started}">
        <awesomeIcon
          v-if="
            status === 'Ingeleverd'
            || status === 'Geaccepteerd'
            || status === 'Ondertekend'
          "
          icon="check"
          color="green"
        />
        Vragenlijst
        <template v-if="status == 'Bezig' && intake.started">
           ({{formatPrice((wrongFields / totalFields) * 100, true)}}%)
        </template>
      </div>
      <div class="step sm-col-3 lg-col-3" :class="{'active': status == 'Ingeleverd'}">
        <awesomeIcon
          v-if="
            status === 'Geaccepteerd'
            || status === 'Ondertekend'
          "
          icon="check"
          color="green"
        />
        Overeenkomst
      </div>
      <div class="step sm-col-3 lg-col-3" :class="{'active': status == 'Geaccepteerd'}">
        <awesomeIcon
          v-if="status === 'Ondertekend'"
          icon="check"
          color="green"
        />
        Plan
      </div>
      <div class="step sm-col-2 lg-col-2" :class="{'active': status == 'Ondertekend'}">
        Beleggen
      </div>
    </div>
    <div class="row steps" v-else>
      <div class="step sm-col-6 lg-col-6" :class="{'active': status == 'Bezig'}">
        <awesomeIcon
          v-if="status === 'Ingeleverd'"
          icon="check"
          color="green"
        />
        Klantprofiel #{{port}}
        <template v-if="status === 'Bezig'">
           ({{formatPrice((wrongFields / totalFields) * 100, true)}}%)
           (
          <span class="red" style="cursor: pointer" @click="stopIntake">
            verwijderen
          </span>
          )
        </template>
      </div>
      <div class="step sm-col-6 lg-col-6" :class="{'active': status == 'Ingeleverd'}">
        Nieuw beleggingsplan
      </div>
    </div>

    <template v-if="status == 'Bezig' || role > 7">
      <template v-if="intake.step==1">
        <atpGoalselect
          v-if="Number(role) === 2"
          v-show="intake.goalData.step == 1"
          ref="goalselect"
          v-model="intake"
        />
        <goalselect
          v-else
          v-show="intake.goalData.step == 1"
          ref="goalselect"
          v-model="intake"
        />
        <goal
          v-if="intake.goalData.step==2"
          ref="goalpage"
          v-model="intake.goalData"
        />
      </template>
      <div v-if="!redo && intake.step == 11 && intake.goalData.type" class="card inset">
        <introduction
          ref="introduction"
          v-model="intake"
        />
        <div v-if="!redo" class="intake-buttons">
          <button @click="storeIntake(menu[activeMenu-1].id, menu[activeMenu-1].subId)">
            <awesomeIcon icon="angle-left"/> Vorige
          </button>
          <button @click="validationModal()" style="float:right">
            Volgende <awesomeIcon icon="angle-right"/>
          </button>
        </div>
      </div>

      <template v-if="intake.step==2">
        <rekeningselect
          v-if="intake.rekeningData.type===null"
          v-model="intake"
        />
        <template v-else>
          <personselect
            v-if="!intake.persoonsData[Number(intake.rekeningData.step)].type"
            v-model="intake"
          />
          <div
            v-if="intake.persoonsData[Number(intake.rekeningData.step)].type"
            class="card inset"
          >
            <person
              v-model="intake.persoonsData[Number(intake.rekeningData.step)]"
              :index="Number(intake.rekeningData.step)"
              :key="Number(intake.rekeningData.step)"
            />
            <div class="intake-buttons">
              <template v-if="menu.length > 0 && !this.redo">
                <button @click="storeIntake(menu[activeMenu-1].id, menu[activeMenu-1].subId)">
                  <awesomeIcon icon="angle-left"/> Vorige
                </button>
                <button @click="validationModal()" style="float:right">
                  Volgende <awesomeIcon icon="angle-right"/>
                </button>
                <button
                  v-if="
                    !port
                    && (intake.goalData.box !== '1' || role > 8)
                    && menu[activeMenu+1]
                    && (menu[activeMenu+1].id == 8 || menu[activeMenu+1].id == 12)
                  "
                  @click="addPerson()"
                  style="float:right;margin-right: 10px"
                >
                  <awesomeIcon icon="user-plus" />
                  Persoon <span class="hide-mobile">toevoegen</span>
                </button>
              </template>
              <button v-else @click="validationModal()" style="float:right">
                Opslaan <awesomeIcon icon="angle-right"/>
              </button>
            </div>
          </div>
        </template>
      </template>

      <div v-if="intake.step==3" class="card inset">
        <company v-model="intake.bedrijfsData" />
        <div class="intake-buttons">
          <template v-if="menu.length > 0 && !this.redo">
            <button @click="storeIntake(menu[activeMenu-1].id, menu[activeMenu-1].subId)">
              <awesomeIcon icon="angle-left"/> Vorige
            </button>
            <button @click="validationModal()" style="float:right">
              Volgende <awesomeIcon icon="angle-right"/>
            </button>
          </template>
          <button v-else @click="validationModal()" style="float:right">
            Opslaan <awesomeIcon icon="angle-right"/>
          </button>
        </div>
      </div>

      <div v-if="intake.step==4" class="card inset">
        <experience v-model="intake.experienceData" />
        <div class="intake-buttons">
          <template v-if="menu.length > 0  && !redo">
            <button @click="storeIntake(menu[activeMenu-1].id, menu[activeMenu-1].subId)">
              <awesomeIcon icon="angle-left"/> Vorige
            </button>
            <button @click="validationModal()" style="float:right;">
              Volgende <awesomeIcon icon="angle-right"/>
            </button>
            <button
              v-if="(
                  !port
                  || intake.rekeningData.type == 'Bedrijfsrekening'
                )
                && (intake.goalData.box !== '1' || role > 8)
                && menu[activeMenu+1]
                && (menu[activeMenu+1].id == 8 || menu[activeMenu+1].id == 12)
              "
              @click="addPerson()"
              style="float:right;margin-right: 10px"
            >
              <awesomeIcon icon="user-plus" /> Persoon <span class="hide-mobile">toevoegen</span>
            </button>
          </template>
          <button v-else @click="validationModal()" style="float:right;">
            Opslaan <awesomeIcon icon="angle-right"/>
          </button>
        </div>
      </div>

      <div v-if="intake.step==12" class="card inset">
        <transfers v-model="intake" />
        <div class="intake-buttons">
          <template v-if="menu.length > 0 && !redo">
            <button @click="storeIntake(menu[activeMenu-1].id, menu[activeMenu-1].subId)">
              <awesomeIcon icon="angle-left"/> Vorige
            </button>
            <button @click="validationModal()" style="float:right;">
              Volgende <awesomeIcon icon="angle-right"/>
            </button>
          </template>
          <button v-else @click="validationModal()" style="float:right;">
            Opslaan <awesomeIcon icon="angle-right"/>
          </button>
        </div>
      </div>

      <div v-if="intake.step==8" class="card inset">
        <risk v-model="intake.goalData" />
        <div class="intake-buttons">
          <template v-if="menu.length > 0 && !redo">
            <button @click="storeIntake(menu[activeMenu-1].id, menu[activeMenu-1].subId)">
              <awesomeIcon icon="angle-left"/> Vorige
            </button>
            <button @click="validationModal()" style="float:right;">
              Volgende <awesomeIcon icon="angle-right"/>
            </button>
          </template>
          <button v-else @click="validationModal()" style="float:right;">
            Opslaan <awesomeIcon icon="angle-right"/>
          </button>
        </div>
      </div>

      <div v-if="intake.step == 13" class="card inset">
        <sustainability v-model="intake.rekeningData" />
        <div class="intake-buttons">
          <template v-if="menu.length > 0 && !redo">
            <button @click="storeIntake(menu[activeMenu-1].id, menu[activeMenu-1].subId)">
              <awesomeIcon icon="angle-left"/> Vorige
            </button>
            <button @click="validationModal()" style="float:right;">
              Volgende <awesomeIcon icon="angle-right"/>
            </button>
          </template>
          <button v-else @click="validationModal()" style="float:right;">
            Opslaan <awesomeIcon icon="angle-right"/>
          </button>
        </div>
      </div>

      <div v-if="intake.step==5" class="card inset">
        <companyFinance
          v-if="
            intake.rekeningData.type === 'Bedrijfsrekening'
            && intake.financeData.step === null
          "
          v-model="intake.financeData"
        />
        <finance
          v-else
          :index="Number(intake.financeData.step)"
          :key="Number(intake.financeData.step)"
          v-model="intake.persoonsData[Number(intake.financeData.step)]"
        />
        <div class="intake-buttons">
          <template v-if="menu.length > 0 && !redo">
            <button @click="storeIntake(menu[activeMenu-1].id, menu[activeMenu-1].subId)">
              <awesomeIcon icon="angle-left"/> Vorige
            </button>
            <button @click="validationModal()" style="float:right;">
              Volgende <awesomeIcon icon="angle-right" />
            </button>
            <button
              v-if="
                (!port || intake.rekeningData.type == 'Bedrijfsrekening')
                && (intake.goalData.box !== '1' || role > 8)
                && menu[activeMenu+1]
                && (menu[activeMenu+1].id == 8 || menu[activeMenu+1].id == 12)"
              @click="addPerson()"
              style="float:right;margin-right: 10px"
            >
              <awesomeIcon icon="user-plus" /> Persoon <span class="hide-mobile">toevoegen</span>
            </button>
          </template>
          <button v-else @click="validationModal()" style="float:right;">
            Opslaan <awesomeIcon icon="angle-right"/>
          </button>
        </div>
      </div>

    </template>

    <overview
      ref="overview"
      v-show="(
        status == 'Bezig'
        && (
          intake.step == 6
          || (role < 8 && intake.step == 9)
          || (role < 8 && intake.step == 10)
          || (!(Number(role) === 2 || Number(role) > 7) && intake.step == 15)
        )
      )
      || (overviewToggle && intake.step == 6 && role > 7)
      "
      v-model="intake"
    />

    <status
      v-if="(status != 'Bezig' && (role < 8 || intake.step == 6)) && !overviewToggle"
      v-model="intakeAdmin"
    />
    <atpConnect
      v-if="((Number(role) === 2 && !this.redo) || Number(role) > 7) && Number(intake.step) === 15"
      v-model="intake"
    />
    <compare
      v-if="role > 7 && intake.step == 14"
    />
    <settings
      v-if="role > 7 && intake.step == 9"
      v-model="intakeAdmin"
    />
    <adminPlan
      v-if="role > 7 && intake.step == 10"
      v-model="intakeAdmin"
    />

  </div>
  <div v-else class="loader" />
</template>

<script>
import { findIndex, filter, find } from 'lodash-es';
import axios from 'axios';
import atpConnect from './intake/connect';
import atpGoalselect from './intake/atpGoalselect';
import sidebar from './ui/sideBar';
import person from './intake/person';
import personselect from './intake/personselect';
import company from './intake/company';
import companyFinance from './intake/companyFinance';
import goal from './intake/goal';
import goalselect from './intake/goalselect';
import finance from './intake/finance';
import experience from './intake/experience';
import overview from './intake/overview';
import rekeningselect from './intake/rekeningselect';
import risk from './intake/risk';
import sustainability from './intake/sustainability';
import status from './intake/status';
import settings from './intake/settings';
import adminPlan from './intake/adminPlan';
import introduction from './intake/introduction';
import transfers from './intake/transfers';
import compare from './intake/compare';

export default {
  name: 'UserIntake',
  components: {
    atpConnect,
    atpGoalselect,
    sidebar,
    person,
    company,
    companyFinance,
    goalselect,
    goal,
    finance,
    experience,
    overview,
    rekeningselect,
    personselect,
    adminPlan,
    risk,
    sustainability,
    status,
    settings,
    introduction,
    transfers,
    compare,
  },
  data() {
    return {
      signing: false,
      style: process.env.VUE_APP_STYLE,
      help: false,
      portValue: 0,
      cashflowDate: null,
      status: null,
      redo: null,
      email: null,
      previousEmail: null,
      previousId: null,
      created: null,
      loaded: false,
      port: null,
      client: 1,
      userOverview: null,
      writeModus: true,
      previousCompleted: null,
      feeoptions: [
        { label: 'Doelbeleggen', value: 'db' },
        { label: 'Oxby', value: 'oxby' },
        { label: 'VM/BVS', value: 'vmbvs' },
        { label: 'Werknemer', value: 'werknemer' },
        { label: 'DB ATP 10%', value: 'dbatp' },
        { label: 'DB ATP all-in (opb)', value: 'dbatpopbouwend' },
        { label: 'DB ATP all-in (uit)', value: 'dbatpuitkerend' },
        { label: 'DB Vrienden/Familie', value: 'dbvriendenfamilie' },
        { label: 'DB VEH', value: 'dbverenigingeigenhuis' },
        { label: 'DB VLK', value: 'dbvanlanschotkempen' },
        { label: 'DB Uitkerend', value: 'dbuitkerend' },
        { label: 'DB Uitkerend geen EU', value: 'dbuitkerendgeeneu' },
        { label: 'Oxby Vrienden/Familie', value: 'oxbyvriendenfamilie' },
        { label: 'VM GIRO', value: 'vmgiro' },
        { label: 'Custom instellingen', value: 'custom' },
        { label: 'Handmatig berekenen', value: 'handmatig' },
      ],
      banken: [
        { label: 'ABN Amro', value: 'ABN Amro' },
        { label: 'Argenta', value: 'Argenta' },
        { label: 'ASN', value: 'ASN' },
        { label: 'Binck / SAXO', value: 'Binck' },
        { label: 'Brand New Day', value: 'Brand New Day' },
        { label: 'Bunq', value: 'Bunq' },
        { label: 'Centraal Beheer', value: 'Centraal Beheer' },
        { label: 'ING', value: 'ING' },
        { label: 'InsingerGilissen', value: 'InsingerGilissen' },
        { label: 'KNAB', value: 'KNAB' },
        { label: 'Leaseplan Bank', value: 'Leaseplan Bank' },
        { label: 'Lloyds bank', value: 'Lloyds bank' },
        { label: 'NN', value: 'NN' },
        { label: 'NIBC', value: 'NIBC' },
        { label: 'Rabobank', value: 'Rabobank' },
        { label: 'Raisin', value: 'Raisin' },
        { label: 'Regiobank', value: 'Regiobank' },
        { label: 'Robeco', value: 'Robeco' },
        { label: 'Saxobank', value: 'Saxobank' },
        { label: 'SNS', value: 'SNS' },
        { label: 'Triodos', value: 'Triodos' },
        { label: 'Van Lanschot', value: 'VanLanschot' },
        { label: 'Anders', value: 'Anders' },
      ],
      beleggingsInstanties: [
        { label: 'ABN Amro', value: 'ABN Amro' },
        { label: 'Aegon', value: 'Aegon' },
        { label: 'ASN', value: 'ASN' },
        { label: 'Binck / SAXO', value: 'Binck' },
        { label: 'Brand New Day', value: 'Brand New Day' },
        { label: 'Crypto', value: 'Crypto' },
        { label: 'Crowdfunding', value: 'Crowdfunding' },
        { label: 'DeGiro', value: 'DeGiro' },
        { label: 'Doelbeleggen.nl', value: 'Doelbeleggen.nl' },
        { label: 'Evi', value: 'Evi' },
        { label: 'Fisher Investments', value: 'Fisher Investments' },
        { label: 'ING', value: 'ING' },
        { label: 'InsingerGilissen', value: 'InsingerGilissen' },
        { label: 'KNAB', value: 'KNAB' },
        { label: 'Lynx', value: 'Lynx' },
        { label: 'NN / Fitvermogen', value: 'NN Fitvermogen' },
        { label: 'NNEK', value: 'NNEK' },
        { label: 'Oakk', value: 'Oakk' },
        { label: 'Peaks', value: 'Peaks' },
        { label: 'Rabobank', value: 'Rabobank' },
        { label: 'Robeco', value: 'Robeco' },
        { label: 'Saxobank', value: 'Saxobank' },
        { label: 'SNS', value: 'SNS' },
        { label: 'Triodos', value: 'Triodos' },
        { label: 'Van Lanschot', value: 'VanLanschot' },
        { label: 'Velthuyse Mulder', value: 'Velthuyse Mulder' },
        { label: 'Anders', value: 'Anders' },
      ],
      hypotheekInstanties: [
        { label: 'ABN Amro', value: 'ABN Amro' },
        { label: 'Aegon', value: 'Aegon' },
        { label: 'Florius', value: 'Florius' },
        { label: 'ING', value: 'ING' },
        { label: 'Nationale Nederlanden', value: 'Nationale Nederlanden' },
        { label: 'NIBC', value: 'NIBC' },
        { label: 'Anders', value: 'Anders' },
      ],
      beleggingsProfielen: [
        { label: 'Defensief', value: 'Defensief' },
        { label: 'Neutraal', value: 'Neutraal' },
        { label: 'Offensief', value: 'Offensief' },
      ],
      bankNames: [
        { label: 'ABN Amro Bank', value: 'ABN' },
        { label: 'ACE Europe Life Limited', value: 'ACE' },
        { label: 'AEGON Bank', value: 'AEGON' },
        { label: 'Allianz Nederland Levensverzekering', value: 'Allianz' },
        { label: 'Amersfoortse Levensverzekeringmaatschappij', value: 'Amersfoortse' },
        { label: 'Argenta Spaarbank', value: 'Argenta' },
        { label: 'ASR Bank', value: 'ASR' },
        { label: 'Avéro Achmea', value: 'AvéroAchmea' },
        { label: 'Bâloise Vie Luxembourg S.A.', value: 'Baloise' },
        { label: 'BLG Wonen', value: 'BLG' },
        { label: 'Brand New Day Bank', value: 'BrandNewDay' },
        { label: 'Centraal Beheer Achmea', value: 'CentraalBeheerAchmea' },
        { label: 'Conservatrix', value: 'Conservatrix' },
        { label: 'Cordares Levensverzekeringen', value: 'Cordares' },
        { label: 'Credit Life AG', value: 'CreditLifeAG' },
        { label: 'DELA Natura- en Levensverzekeringen', value: 'DELA' },
        { label: 'Doelbeleggen', value: 'DB' },
        { label: 'FBTO', value: 'FBTO' },
        { label: 'FlexGarant Assuradeuren B.V.', value: 'FlexGarant' },
        { label: 'Goudse Levensverzekeringen', value: 'GoudseLevensverzekeringen' },
        { label: 'ING Bank', value: 'ING' },
        { label: 'Interpolis', value: 'Interpolis' },
        { label: 'Klaverblad Levensverzekering', value: 'Klaverblad' },
        { label: 'Leidsche Verzekering Maatschappij', value: 'Leidsche' },
        { label: 'Monuta Verzekeringen', value: 'Monuta' },
        { label: 'Nationale-Nederlanden Bank', value: 'NationaleNederlanden' },
        { label: 'Ohra Levensverzekeringen', value: 'Ohra' },
        { label: "Onderlinge Levensverzekering-Maatschappij 's-Gravenhage'", value: 'OnderlingeLevensverzekering' },
        { label: 'Quantum Leben AG', value: 'Quantum' },
        { label: 'Rabobank Nederland', value: 'Rabobank' },
        { label: 'Regiobank', value: 'Regiobank' },
        { label: 'Robein leven', value: 'Robein' },
        { label: 'Scildon', value: 'Scildon' },
        { label: 'SNS', value: 'SNS' },
        { label: 'SRLEV', value: 'SRLEV' },
        { label: 'Universal Leven', value: 'UniversalLeven' },
        { label: 'Van Lanschot Bankiers', value: 'VanLanschotBankiers' },
        { label: 'Waard Verzekeringen', value: 'Waard' },
        { label: 'WestlandUtrecht Bank', value: 'westlandUtrecht' },
        { label: 'Anders', value: 'Anders' },
      ],
      brancheList: [
        {
          branche: 'Bouw en infrastructuur',
          code: 'bouw',
          sectors: [
            {
              name: 'Afvalbeheer en sanering',
              code: 'bouw-afval',
            },
            {
              name: 'Baggerwerkzaamheden',
              code: 'bouw-bagger',
            },
            {
              name: 'Offshore',
              code: 'bouw-offshore',
            },
            {
              name: 'Watervoorziening en riolering',
              code: 'bouw-water',
            },
          ],
        },
        {
          branche: 'Cash intensieve sector',
          code: 'cash',
          sectors: [
            {
              name: 'Horeca (hotels, cafetaria etc.)',
              code: 'cash-horeca',
            },
            {
              name: 'Pandjeshuizen',
              code: 'cash-pand',
            },
            {
              name: 'Bloemenhandelaars',
              code: 'cash-bloemen',
            },
            {
              name: 'Marktkooplieden',
              code: 'cash-markt',
            },
            {
              name: 'Persoonlijke verzorging (zonnebanken, massage salon etc.)',
              code: 'cash-pers-verz',
            },
            {
              name: 'Belwinkels',
              code: 'cash-bel',
            },
            {
              name: 'Autohandelaren',
              code: 'cash-auto',
            },
            {
              name: 'Garages',
              code: 'cash-garages',
            },
            {
              name: 'Ijzerhandel',
              code: 'cash-ijzer',
            },
            {
              name: 'Seksindustrie',
              code: 'cash-seksind',
            },
          ],
        },
        {
          branche: 'Charitatieve/non-profit instellingen',
          code: 'char',
          sectors: [
            {
              name: 'Goede doelen',
              code: 'char-goed-doel',
            },
          ],
        },
        {
          branche: 'Farmaceutische sector',
          code: 'farma',
          sectors: [
            {
              name: 'Fabrikant geneesmiddelen',
              code: 'farma-fabri-genees',
            },
            {
              name: 'Groothandel geneesmiddelen',
              code: 'farma-groot-genees',
            },
            {
              name: 'Apotheek',
              code: 'farma-apotheek',
            },
          ],
        },
        {
          branche: 'Financieel',
          code: 'fin',
          sectors: [
            {
              name: 'Betalingsdiensten of vergelijkbaar (PSP)',
              code: 'fin-psp',
            },
            {
              name: 'Crowdfunding',
              code: 'fin-crowdfunding',
            },
            {
              name: 'Handel in/mining van cryptovaluta of Initial Coin Offering (ICO)',
              code: 'fin-crypto-ico',
            },
          ],
        },
        {
          branche: 'Gok & kansspel industrie',
          code: 'gok',
          sectors: [
            {
              name: 'Loterijen en kansspelen',
              code: 'gok-loterij',
            },
            {
              name: 'Exploitatie van amusements- en speelautomaten',
              code: 'gok-exploi',
            },
            {
              name: 'Casino',
              code: 'gok-casino',
            },
          ],
        },
        {
          branche: 'Handel',
          code: 'handel',
          sectors: [
            {
              name: 'Cryptovaluta of Initial Coin Offering (ICO)',
              code: 'handel-crypto-ico',
            },
            {
              name: 'Juwelen (bijv. edelmetalen of diamanten)',
              code: 'handel-juwelen',
            },
            {
              name: 'Kunsthandel',
              code: 'handel-kunsthandel',
            },
            {
              name: 'Veilingen',
              code: 'handel-veiling',
            },
            {
              name: 'Wapens of andere militaire goederen',
              code: 'handel-militair',
            },
          ],
        },
        {
          branche: 'Horeca',
          code: 'horeca',
          sectors: [
            {
              name: 'Hotel',
              code: 'horeca-hotel',
            },
            {
              name: 'Restaurant',
              code: 'horeca-rest',
            },
            {
              name: 'Cafetaria',
              code: 'horeca-cafe',
            },
          ],
        },
        {
          branche: 'ICT, telecom en online',
          code: 'ict',
          sectors: [
            {
              name: 'Betalingsdiensten of vergelijkbaar (PSP)',
              code: 'ict-psp',
            },
            {
              name: 'Crowdfunding',
              code: 'ict-crowdfunding',
            },
            {
              name: 'Handel in cryptovaluta of Initial Coin Offering (ICO)',
              code: 'ict-crypto-ico',
            },
            {
              name: '(Online) gamen en gokken',
              code: 'ict-gamen-gokken',
            },
            {
              name: 'Peer-to-peer-platforms voor krediet- en betaaldiensten (Uber, Ebay, Airbnb, bol.com, Marktplaats)',
              code: 'ict-p2p',
            },
          ],
        },
        {
          branche: 'Industrie',
          code: 'ind',
          sectors: [
            {
              name: 'Afvalbeheer en sanering',
              code: 'ind-afval',
            },
            {
              name: 'Fabricage / productie',
              code: 'ind-fabricage',
            },
            {
              name: 'Farmaceutische industrie',
              code: 'ind-farma',
            },
            {
              name: 'Grondstoffen, mineralen, mijnbouw en steenhouwerij',
              code: 'ind-grondstoffen',
            },
            {
              name: 'Olie- en gasindustrie',
              code: 'ind-olie-gas',
            },
            {
              name: 'Seksindustrie',
              code: 'ind-seksind',
            },
            {
              name: 'Watervoorziening en riolering',
              code: 'ind-water',
            },
          ],
        },
        {
          branche: 'Kerkgenootschappen',
          code: 'kerk',
          sectors: [
            {
              name: 'Religieuze organisaties',
              code: 'kerk-reli',
            },
          ],
        },
        {
          branche: 'Kunst, amusement en recreatie',
          code: 'kunst',
          sectors: [
            {
              name: 'Kunsthandel',
              code: 'kunst-handel',
            },
            {
              name: 'Seksindustrie',
              code: 'kunst-seksind',
            },
          ],
        },
        {
          branche: 'Landbouw, bosbouw en visserij',
          code: 'landbouw',
          sectors: [
            {
              name: 'Landbouw',
              code: 'landbouw-land',
            },
            {
              name: 'Bosbouw',
              code: 'landbouw-bos',
            },
            {
              name: 'Visserij',
              code: 'landbouw-vis',
            },
          ],
        },
        {
          branche: 'Overheid',
          code: 'overheid',
          sectors: [
            {
              name: 'Afvalbeheer en sanering',
              code: 'overheid-afval',
            },
            {
              name: 'Onderwijs',
              code: 'overheid-onderwijs',
            },
            {
              name: 'Overheidsinstellingen',
              code: 'overheid-instel',
            },
            {
              name: 'Watervoorziening en riolering',
              code: 'overheid-water',
            },
            {
              name: 'Wetenschappelijk onderzoek',
              code: 'overheid-wetenschap',
            },
          ],
        },
        {
          branche: 'Sport',
          code: 'sport',
          sectors: [
            {
              name: 'Professionele sport',
              code: 'sport-prof',
            },
            {
              name: 'Scheidsrechters',
              code: 'sport-scheids',
            },
            {
              name: 'Professionele managers',
              code: 'sport-mngr',
            },
          ],
        },
        {
          branche: 'Vervoer, transport en logistiek',
          code: 'ver',
          sectors: [
            {
              name: 'Opslag van goederen',
              code: 'ver-opslag',
            },
            {
              name: 'Scheepvaart',
              code: 'ver-scheep',
            },
          ],
        },
        {
          branche: 'Vastgoed',
          code: 'vastgoed',
          sectors: [
            {
              name: 'Investeerder',
              code: 'vastgoed-invest',
            },
            {
              name: 'Bouwsector',
              code: 'vastgoed-bouw',
            },
            {
              name: 'Makelaardij',
              code: 'vastgoed-makelaar',
            },
          ],
        },
        {
          branche: 'Zakelijk en commercieel',
          code: 'zak-com',
          sectors: [
            {
              name: 'Adviesdiensten en consultancy',
              code: 'zak-com-advies',
            },
            {
              name: 'Afvalbeheer en sanering',
              code: 'zak-com-afval',
            },
            {
              name: 'Coffeeshop of growshop',
              code: 'zak-com-shop',
            },
            {
              name: 'Commerciële vastgoedactiviteiten',
              code: 'zak-com-vastgoed',
            },
            {
              name: 'Handel in juwelen of juwelier',
              code: 'zak-com-juwel',
            },
            {
              name: 'Handel in wapens of andere militaire goederen',
              code: 'zak-com-militair',
            },
            {
              name: 'Opslag van goederen',
              code: 'zak-com-opslag',
            },
            {
              name: 'Seksindustrie',
              code: 'zak-com-seksind',
            },
            {
              name: 'Trustkantoren (Corporate Service Providers)',
              code: 'zak-com-trust',
            },
            {
              name: 'Veilingen',
              code: 'zak-com-veiling',
            },
            {
              name: 'Watervoorziening en riolering',
              code: 'zak-com-water',
            },
          ],
        },
        {
          branche: 'Zorg en welzijn',
          code: 'zorg',
          sectors: [
            {
              name: 'Zonnebanksalons',
              code: 'zorg-zonbank',
            },
            {
              name: 'Persoonlijke verzorging',
              code: 'zorg-pers-verz',
            },
            {
              name: 'Massagesalons',
              code: 'zorg-massage',
            },
          ],
        },
      ],
      allowedCountries: {
        BE: 'België',
        CY: 'Cyprus',
        DK: 'Denemarken',
        DE: 'Duitsland',
        FI: 'Finland',
        FR: 'Frankrijk',
        GR: 'Griekenland',
        HU: 'Hongarije',
        IE: 'Ierland',
        IT: 'Italië',
        LU: 'Luxemburg',
        MT: 'Malta',
        NL: 'Nederland',
        NO: 'Noorwegen',
        AT: 'Oostenrijk',
        PL: 'Polen',
        PT: 'Portugal',
        RO: 'Roemenië',
        ES: 'Spanje',
        CZ: 'Tsjechië',
        GB: 'Verenigd Koninkrijk',
        SE: 'Zweden',
        CH: 'Zwitserland',
      },
      allCountries: {
        AF: 'Afghanistan',
        AX: 'Åland',
        AL: 'Albanië',
        DZ: 'Algerije',
        VI: 'Amerikaanse Maagdeneilanden',
        AS: 'Amerikaans-Samoa',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctica',
        AG: 'Antigua en Barbuda',
        AR: 'Argentinië',
        AM: 'Armenië',
        AW: 'Aruba',
        AU: 'Australië',
        AZ: 'Azerbeidzjan',
        BS: 'Bahama\'s',
        BH: 'Bahrein',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BE: 'België',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivia',
        BA: 'Bosnië en Herzegovina',
        BW: 'Botswana',
        BV: 'Bouvet',
        BR: 'Brazilië',
        VG: 'Britse Maagdeneilanden',
        IO: 'Brits Indische Oceaanterritorium',
        BN: 'Brunei',
        BG: 'Bulgarije',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        KH: 'Cambodja',
        CA: 'Canada',
        BQ: 'Caribisch Nederland',
        CF: 'Centraal-Afrikaanse Republiek',
        CL: 'Chili',
        CN: 'China',
        CX: 'Christmaseiland',
        CC: 'Cocoseilanden',
        CO: 'Colombia',
        KM: 'Comoren',
        CG: 'Congo-Brazzaville',
        CD: 'Congo-Kinshasa',
        CK: 'Cookeilanden',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CW: 'Curaçao',
        CY: 'Cyprus',
        DK: 'Denemarken',
        DJ: 'Djibouti',
        DM: 'Dominica',
        DO: 'Dominicaanse Republiek',
        DE: 'Duitsland',
        EC: 'Ecuador',
        EG: 'Egypte',
        SV: 'El Salvador',
        GQ: 'Equatoriaal-Guinea',
        ER: 'Eritrea',
        EE: 'Estland',
        ET: 'Ethiopië',
        FO: 'Faeröer',
        FK: 'Falklandeilanden',
        FJ: 'Fiji',
        PH: 'Filipijnen',
        FI: 'Finland',
        FR: 'Frankrijk',
        TF: 'Franse Zuidelijke Gebieden',
        GF: 'Frans-Guyana',
        PF: 'Frans-Polynesië',
        GA: 'Gabon',
        GM: 'Gambia',
        GE: 'Georgië',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GD: 'Grenada',
        GR: 'Griekenland',
        GL: 'Groenland',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GN: 'Guinee',
        GW: 'Guinee-Bissau',
        GY: 'Guyana',
        HT: 'Haïti',
        HM: 'Heard en McDonaldeilanden',
        HN: 'Honduras',
        HU: 'Hongarije',
        HK: 'Hongkong',
        IE: 'Ierland',
        IS: 'IJsland',
        IN: 'India',
        ID: 'Indonesië',
        IQ: 'Irak',
        IR: 'Iran',
        IL: 'Israël',
        IT: 'Italië',
        CI: 'Ivoorkust',
        JM: 'Jamaica',
        JP: 'Japan',
        YE: 'Jemen',
        JE: 'Jersey',
        JO: 'Jordanië',
        KY: 'Kaaimaneilanden',
        CV: 'Kaapverdië',
        CM: 'Kameroen',
        KZ: 'Kazachstan',
        KE: 'Kenia',
        KG: 'Kirgizië',
        KI: 'Kiribati',
        UM: 'Kleine afgelegen eilanden van de Verenigde Staten',
        KW: 'Koeweit',
        HR: 'Kroatië',
        LA: 'Laos',
        LS: 'Lesotho',
        LV: 'Letland',
        LB: 'Libanon',
        LR: 'Liberia',
        LY: 'Libië',
        LI: 'Liechtenstein',
        LT: 'Litouwen',
        LU: 'Luxemburg',
        MO: 'Macau',
        MG: 'Madagaskar',
        MW: 'Malawi',
        MV: 'Maldiven',
        MY: 'Maleisië',
        ML: 'Mali',
        MT: 'Malta',
        IM: 'Man',
        MA: 'Marokko',
        MH: 'Marshalleilanden',
        MQ: 'Martinique',
        MR: 'Mauritanië',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MX: 'Mexico',
        FM: 'Micronesia',
        MD: 'Moldavië',
        MC: 'Monaco',
        MN: 'Mongolië',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibië',
        NR: 'Nauru',
        NL: 'Nederland',
        NP: 'Nepal',
        NI: 'Nicaragua',
        NC: 'Nieuw-Caledonië',
        NZ: 'Nieuw-Zeeland',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        MP: 'Noordelijke Marianen',
        KP: 'Noord-Korea',
        MK: 'Noord-Macedonië',
        NO: 'Noorwegen',
        NF: 'Norfolk',
        UG: 'Oeganda',
        UA: 'Oekraïne',
        UZ: 'Oezbekistan',
        OM: 'Oman',
        AT: 'Oostenrijk',
        TL: 'Oost-Timor',
        PK: 'Pakistan',
        PW: 'Palau',
        PS: 'Palestina',
        PA: 'Panama',
        PG: 'Papoea-Nieuw-Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PN: 'Pitcairneilanden',
        PL: 'Polen',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        QA: 'Qatar',
        RE: 'Réunion',
        RO: 'Roemenië',
        RU: 'Rusland',
        RW: 'Rwanda',
        BL: 'Saint-Barthélemy',
        KN: 'Saint Kitts en Nevis',
        LC: 'Saint Lucia',
        PM: 'Saint-Pierre en Miquelon',
        VC: 'Saint Vincent en de Grenadines',
        SB: 'Salomonseilanden',
        WS: 'Samoa',
        SM: 'San Marino',
        SA: 'Saoedi-Arabië',
        ST: 'Sao Tomé en Principe',
        SN: 'Senegal',
        RS: 'Servië',
        SC: 'Seychellen',
        SL: 'Sierra Leone',
        SG: 'Singapore',
        SH: 'Sint-Helena, Ascension en Tristan da Cunha',
        MF: 'Sint-Maarten',
        SX: 'Sint Maarten',
        SI: 'Slovenië',
        SK: 'Slowakije',
        SD: 'Soedan',
        SO: 'Somalië',
        ES: 'Spanje',
        SJ: 'Spitsbergen en Jan Mayen',
        LK: 'Sri Lanka',
        SR: 'Suriname',
        SZ: 'Swaziland',
        SY: 'Syrië',
        TJ: 'Tadzjikistan',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        TH: 'Thailand',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad en Tobago',
        TD: 'Tsjaad',
        CZ: 'Tsjechië',
        TN: 'Tunesië',
        TR: 'Turkije',
        TM: 'Turkmenistan',
        TC: 'Turks- en Caicoseilanden',
        TV: 'Tuvalu',
        UY: 'Uruguay',
        VU: 'Vanuatu',
        VA: 'Vaticaanstad',
        VE: 'Venezuela',
        AE: 'Verenigde Arabische Emiraten',
        US: 'Verenigde Staten',
        GB: 'Verenigd Koninkrijk',
        VN: 'Vietnam',
        WF: 'Wallis en Futuna',
        EH: 'Westelijke Sahara/SADR',
        BY: 'Wit-Rusland',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
        ZA: 'Zuid-Afrika',
        GS: 'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
        KR: 'Zuid-Korea',
        SS: 'Zuid-Soedan',
        SE: 'Zweden',
        CH: 'Zwitserland',
      },
      id: null,
      completeDate: null,
      value: 0,
      name: '',
      intakeAdmin: {
        updated: null,
        rekeningStatus: null,
        rekening: {
        },
        beleggen: {
          feeLocked: true,
          feeName: 'db',
          feeFixed: '0',
          feeAmount1: '0.18750', // 0 - 250 k
          feeAmount2: '0.18750', // 250k- 500 k
          feeAmount3: '0.18750', // 500k - 1m
          feeAmount4: '0.18750', // 1m+
          feePerformance: '0',
          feeWatermarkPeriod: '0',
          feeBtw: 'Yes',
          feeNote: '',
          feeMinimalWatermark: '',
          feeMainWallet: '',
          type: '',
          maxProfile: '',
          profile: '',
          lifecycle: '',
          lifecycleDisabled: '',
          brand: '',
          report: '',
          contact: '',
          geenOptiesDate: '',
          geenOpties: '',
          optiedalingMeldingDate: '',
          optiedalingMelding: '',
          debetstandDate: '',
          debetstand: '',
          manager: '',
          managerName: '',
          sales: '',
          salesName: '',
          keepManager: 'No',
        },
        publicNote: '',
        cddStatus: {
          handedText: '', // CDD ingediend
          text: '', // CDD afgerond
          resetText: '', // CDD gereset
        },
        scopeOnDemand: {},
        status: '{}',
        offers: {},
        offerMailCounter: 0,
        offerMailUser: 0,
        offerMailDate: '',
      },
      intake: {
        persoonsData: [{ spaarrekening: 'Yes' }],
        offers: [],
        rekeningData: {
          step: null,
          type: null,
          docRead: false,
          iban: '',
          sustainability: '',
          sustainabilityNew: '',
          sustainabilityEcologicPreference: '',
          sustainabilityEffect: '',
          sustainabilityPaiConsider: '',
          sustainabilityPaiManagement: '',
          sustainabilityPaiSocial: '',
          sustainabilityPaiEnvironment: '',
          acceptSustainabilityText: '',
          uitzonderingloonheffing: null,
          uitzonderingloonheffingBedrag: null,
          uitzonderingloonheffingDatum: null,
          loonheffingskorting: null,
          paymentStart: null,
        },
        bedrijfsData: {
          land: 'Nederland',
          rechtsvorm: null,
          rechtsvormAnders: null,
        },
        atpData: {
          connected: false,
          email: null,
          kosten: null,
          vergoedingEenmalig: null,
          vergoedingJaar: null,
          vergoedingPercentageJaar: null,
        },
        advisorDetails: {},
        goalData: {
          step: 1,
          type: '',
          box: '3',
          risk: null,
          risk2: null,
          risk3: null,
          risk4: null,
          risk5: null,
          stortingenInterval: 'Per maand',
          onttrekkingen: 'No',
          onttrekkingenInterval: 'Per maand',
          score: 0,
          looptijd: '10',
          targetDate: '',
          leeftijd: '50',
          leeftijdKindTot: '18',
          leeftijdKind: '3',
          pensioenLeeftijd: '67',
          uitkeringsPeriode: '20',
          stepout: '0',
          warning: '0',
          vermogen: '20000',
          stortingen: 'Yes',
          stortingenBedrag: '150',
          doel: '45000',
          doelAanvulling: '1000',
          extrarendement: '20',
          inflatie: 'Yes',
          vermogensbelasting: 'Yes',
          collect: null,
          offerType: '1',
          offerShowInputs: true,
          nextOfKin: 'false',
        },
        experienceData: {
          opleiding: null,
          nieuws: null,
          ervaring: null,
          ervaringTrackers: null,
          ervaringAandelen: null,
          ervaringObligaties: null,
          ervaringOpties: null,
        },
        transferData: {
          overdrachten: [],
        },
        financeData: {
          step: null,
          negatiefVermorgen: null,
          uitgeleend: null,
          uitgeleendU: null,
          jaarrekeningMethode: null,
          files: null,
          jaarrekening: null,
          statuten: null,
          // Company finance details
          spaarrekening: null,
          spaarrekeningBedrag: null,
          spaarrekeningInstantie: null,
          spaarrekeningInstantieOmschrijving: null,
          spaarrekening2: null,
          spaarrekening2Bedrag: null,
          spaarrekening2Instantie: null,
          spaarrekening2InstantieOmschrijving: null,
          spaarrekening3: null,
          spaarrekening3Bedrag: null,
          spaarrekening3Instantie: null,
          spaarrekening3InstantieOmschrijving: null,
          beleggingen: null,
          beleggingenTypeDienst: null,
          beleggingenBedrag: null,
          beleggingenProfiel: null,
          beleggingenInstantie: null,
          beleggingenInstantieOmschrijving: null,
          beleggingenMeer: null,
          beleggingenMeerTypeDienst: null,
          beleggingenMeerBedrag: null,
          beleggingenMeerProfiel: null,
          beleggingenMeerInstantie: null,
          beleggingenMeerInstantieOmschrijving: null,
          beleggingenNogMeer: null,
          beleggingenNogMeerTypeDienst: null,
          beleggingenNogMeerBedrag: null,
          beleggingenNogMeerProfiel: null,
          beleggingenNogMeerInstantie: null,
          beleggingenNogMeerInstantieOmschrijving: null,
          onroerendgoed: null,
          onroerendgoedCommercieel: null,
          onroerendgoedVrijeverkoopwaarde: null,
          onroerendgoedBedragPerJaar: null,
          overigOnroerendgoed: null,
          overigOnroerendgoedObjecten: null,
          overigOnroerendgoedCommercieel: null,
          overigOnroerendgoedCommercieelObjecten: null,
          overigOnroerendgoedVrijeverkoopwaarde: null,
          overigOnroerendgoedBedragPerJaar: null,
          hypotheekVastgoed: null,
          hypotheekVastgoedType: null,
          hypotheekVastgoedWaarde: null,
          hypotheekVastgoedInstantie: null,
          hypotheekVastgoedInstantieOmschrijving: null,
          hypotheekVastgoedRenteType: null,
          hypotheekVastgoedRente: null,
          hypotheekVastgoedLooptijd: null,
          hypotheekVastgoed2: null,
          hypotheekVastgoed2Type: null,
          hypotheekVastgoed2Waarde: null,
          hypotheekVastgoed2Instantie: null,
          hypotheekVastgoed2InstantieOmschrijving: null,
          hypotheekVastgoed2RenteType: null,
          hypotheekVastgoed2Rente: null,
          hypotheekVastgoed2Looptijd: null,
          hypotheekVastgoed3: null,
          hypotheekVastgoed3Type: null,
          hypotheekVastgoed3Waarde: null,
          hypotheekVastgoed3Instantie: null,
          hypotheekVastgoed3InstantieOmschrijving: null,
          hypotheekVastgoed3RenteType: null,
          hypotheekVastgoed3Rente: null,
          hypotheekVastgoed3Looptijd: null,
        },
        utm: {
        },
        step: 1,
        version: 2,
      },
      previousIntakeAdmin: {
        updated: null,
        rekeningStatus: null,
        rekening: {
        },
        beleggen: {
        },
      },
      previousIntake: {
        persoonsData: [{}],
        offers: [],
        rekeningData: {
          step: null,
          type: null,
          docRead: false,
          iban: '',
          sustainability: '',
        },
        atpData: {
          connected: false,
          email: null,
          kosten: null,
          vergoedingEenmalig: null,
          vergoedingJaar: null,
          vergoedingPercentageJaar: null,
        },
        advisorDetails: {},
        bedrijfsData: {},
        goalData: {
          step: 1,
          type: '',
          stortingenInterval: 'Per maand',
          onttrekkingen: '',
          onttrekkingenInterval: 'Per maand',
          score: 0,
          looptijd: '10',
          targetDate: '',
          leeftijd: '50',
          leeftijdKindTot: '18',
          leeftijdKind: '3',
          pensioenLeeftijd: '67',
          uitkeringsPeriode: '20',
          stepout: '0',
          warning: '0',
          vermogen: '20000',
          stortingen: 'Yes',
          stortingenBedrag: '150',
          doel: '45000',
          doelAanvulling: '1000',
          extrarendement: '20',
          inflatie: 'Yes',
          vermogensbelasting: 'Yes',
          collect: null,
        },
        experienceData: {
        },
        transferData: {
        },
        financeData: {
          step: null,
          negatiefVermorgen: null,
          uitgeleend: null,
          uitgeleendU: null,
          jaarrekeningMethode: null,
          files: null,
          jaarrekening: null,
        },
        step: 1,
        version: 2,
      },
      menu: [],
      activeMenu: null,
      users: [],
      extraPorts: [],
      files: [],
      profiles: [],
      overviewToggle: false,
      feeList: [
        {
          feeName: 'db', // Doelbeleggen
          feeAmount1: '0.18750', // 0 - 250 k
          feeAmount2: '0.18750', // 250k- 500 k
          feeAmount3: '0.18750', // 500k - 1m
          feeAmount4: '0.18750', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '0',
          feeWatermarkPeriod: '0',
        },
        {
          feeName: 'oxby', // Oxby
          feeAmount1: '0.21250', // 0 - 250 k
          feeAmount2: '0.21250', // 250k- 500 k
          feeAmount3: '0.21250', // 500k - 1m
          feeAmount4: '0.21250', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '10',
          feeWatermarkPeriod: '24',
        },
        {
          feeName: 'vmbvs', // VM/BVS
          feeAmount1: '0.30000', // 0 - 250 k
          feeAmount2: '0.25000', // 250k- 500 k
          feeAmount3: '0.20000', // 500k - 1m
          feeAmount4: '0.15000', // 1m+
          feeLocked: true,
          feeFixed: '50',
          feeAdminPayment: '0',
          feePerformance: '10',
          feeWatermarkPeriod: '12',
        },
        {
          feeName: 'werknemer', // Werknemer
          feeAmount1: '0', // 0 - 250 k
          feeAmount2: '0', // 250k- 500 k
          feeAmount3: '0', // 500k - 1m
          feeAmount4: '0', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '0',
          feeWatermarkPeriod: '0',
        },
        {
          feeName: 'dbatp', // DB ATP
          feeAmount1: '0.16875', // 0 - 250 k
          feeAmount2: '0.16875', // 250k- 500 k
          feeAmount3: '0.16875', // 500k - 1m
          feeAmount4: '0.16875', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '0',
          feeWatermarkPeriod: '0',
        },
        {
          feeName: 'dbatpopbouwend', // DB ATP OPBOUWEND
          feeAmount1: '0.16250', // 0 - 250 k
          feeAmount2: '0.16250', // 250k- 500 k
          feeAmount3: '0.13750', // 500k - 1m
          feeAmount4: '0.11250', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '0',
          feeWatermarkPeriod: '0',
        },
        {
          feeName: 'dbatpuitkerend', // DB ATP UITKEREND
          feeAmount1: '0.16250', // 0 - 250 k
          feeAmount2: '0.16250', // 250k- 500 k
          feeAmount3: '0.13750', // 500k - 1m
          feeAmount4: '0.11250', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '0',
          feeWatermarkPeriod: '0',
        },
        {
          feeName: 'dbvriendenfamilie', // DB Vrienden/Familie
          feeAmount1: '0.09375', // 0 - 250 k
          feeAmount2: '0.09375', // 250k- 500 k
          feeAmount3: '0.09375', // 500k - 1m
          feeAmount4: '0.09375', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '0',
          feeWatermarkPeriod: '0',
        },
        {
          feeName: 'dbverenigingeigenhuis', // DB VEH
          feeAmount1: '0.16875', // 0 - 250 k
          feeAmount2: '0.16875', // 250k- 500 k
          feeAmount3: '0.16875', // 500k - 1m
          feeAmount4: '0.16875', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '0',
          feeWatermarkPeriod: '0',
        },
        {
          feeName: 'dbvanlanschotkempen', // DB VLK
          feeAmount1: '0.16875', // 0 - 250 k
          feeAmount2: '0.16875', // 250k- 500 k
          feeAmount3: '0.16875', // 500k - 1m
          feeAmount4: '0.16875', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '0',
          feeWatermarkPeriod: '0',
        },
        {
          feeName: 'dbuitkerend', // DB Uitkerend
          feeAmount1: '0.18750', // 0 - 250 k
          feeAmount2: '0.18750', // 250k- 500 k
          feeAmount3: '0.18750', // 500k - 1m
          feeAmount4: '0.18750', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0.0625',
          feePerformance: '0',
          feeWatermarkPeriod: '0',
        },
        {
          feeName: 'dbuitkerendgeeneu', // DB Uitkerend geen EU
          feeAmount1: '0.18750', // 0 - 250 k
          feeAmount2: '0.18750', // 250k- 500 k
          feeAmount3: '0.18750', // 500k - 1m
          feeAmount4: '0.18750', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0.125',
          feePerformance: '0',
          feeWatermarkPeriod: '0',
        },
        {
          feeName: 'oxbyvriendenfamilie', // Oxby Vrienden/familie
          feeAmount1: '0.10625', // 0 - 250 k
          feeAmount2: '0.10625', // 250k- 500 k
          feeAmount3: '0.10625', // 500k - 1m
          feeAmount4: '0.10625', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '5',
          feeWatermarkPeriod: '24',
        },
        {
          feeName: 'vmgiro', // VM GIRO
          feeAmount1: '0.30000', // 0 - 250 k
          feeAmount2: '0.25000', // 250k- 500 k
          feeAmount3: '0.20000', // 500k - 1m
          feeAmount4: '0.15000', // 1m+
          feeLocked: true,
          feeFixed: '0',
          feeAdminPayment: '0',
          feePerformance: '10',
          feeWatermarkPeriod: '12',
        },
        {
          feeName: 'custom', // Custom instellingen
          feeLocked: false,
        },
        {
          feeName: 'handmatig', // Handmatig berekenen
          feeLocked: false,
        },
      ],
      rechtsvormen: [
        { label: 'Besloten Vennootschap (BV)', value: 'bv' },
        { label: 'Vennootschap Onder Firma (VOF)', value: 'vof' },
        { label: 'Commanditaire Vennootschap (CV)', value: 'cv' },
        { label: 'Naamloze Vennootschap (NV)', value: 'nz' },
        { label: 'Stichting', value: 'stichting' },
        { label: 'Eenmanszaak', value: 'eenmanszaak' },
        { label: 'Maatschap', value: 'maatschap' },
        { label: 'Anders', value: 'anders' },
      ],
    };
  },
  watch: {
    intake: {
      handler() {
        this.$nextTick(() => {
          const tempMenu = [];
          if (this.status === 'Bezig' && Number(this.role) === 2 && !this.redo) {
            tempMenu.push({
              id: 15,
              name: 'Klantkoppeling',
              icon: 'user-tag',
              valid: false,
              focus: this.intake.step === 15,
            });
          }
          if (this.status === 'Bezig' || this.role > 7) {
            if (!this.redo || this.role > 7) {
              tempMenu.push({
                id: 1,
                name: 'Doel',
                icon: 'fa-regular fa-circle-dot',
                valid: false,
                focus:
                this.intake.step === 1,
              });
            }
            if (!this.redo && this.intake.goalData.type) {
              tempMenu.push({
                id: 11,
                name: 'Introductie',
                icon: 'info',
                valid: false,
                focus: this.intake.step === 11,
              });
            }
            if (this.intake.rekeningData.type && (!this.redo || this.role > 7)) {
              if (this.intake.rekeningData.type === 'Bedrijfsrekening') {
                tempMenu.push({
                  id: 3,
                  name: 'Bedrijf',
                  icon: 'suitcase',
                  valid: false,
                  focus: this.intake.step === 3,
                });
                tempMenu.push({
                  id: 5,
                  name: 'Financiële situatie',
                  icon: 'level-up-alt',
                  valid: false,
                  rotation: 90,
                  focus: this.intake.step === 5 && this.intake.financeData.step === null,
                });
              }
              for (let i = 0; i < this.intake.persoonsData.length; i += 1) {
                if (!this.intake.persoonsData[i].sterfteDatum || this.role > 7) {
                  let name;
                  if (i === 0) {
                    name = 'U';
                  } else {
                    name = this.intake.persoonsData[i].type;
                    if (this.intake.persoonsData[i].achternaam) {
                      name = `${
                        this.intake.persoonsData[i].voorletters
                          ? `${this.intake.persoonsData[i].voorletters} `
                          : ''
                      }${
                        this.intake.persoonsData[i].tussenvoegsel
                          ? `${this.intake.persoonsData[i].tussenvoegsel} `
                          : ''
                      }${
                        this.intake.persoonsData[i].achternaam
                          ? this.intake.persoonsData[i].achternaam
                          : ''
                      }`;
                    }
                  }
                  if (
                    this.intake.persoonsData[i].type
                    && name !== this.intake.persoonsData[i].type
                  ) {
                    name = `${name} (${this.intake.persoonsData[i].type})`;
                  }
                  tempMenu.push({
                    id: 2,
                    subId: i,
                    name,
                    icon: this.intake.persoonsData[i].sterfteDatum ? 'user-slash' : 'user',
                    valid: false,
                    focus: Number(this.intake.step) === 2
                      && Number(this.intake.rekeningData.step) === i,
                  });
                  if (i === 0) {
                    tempMenu.push({
                      id: 4,
                      subId: i,
                      name: 'Kennis & ervaring',
                      icon: 'level-up-alt',
                      rotation: 90,
                      valid: false,
                      focus: this.intake.step === 4,
                    });
                  }
                  if (
                    (this.intake.persoonsData[i].type === 'Volmacht' && this.intake.rekeningData.type === 'Minderjarige rekening')
                    || (this.intake.persoonsData[i].type === 'Rekeninghouder' && this.intake.rekeningData.type === 'Particuliere rekening')
                    || (this.intake.rekeningData.type === 'Bedrijfsrekening' && this.intake.persoonsData[i].type !== 'Volmacht')
                  ) {
                    tempMenu.push({
                      id: 5,
                      subId: i,
                      name: 'Financiële situatie',
                      icon: 'level-up-alt',
                      rotation: 90,
                      valid: false,
                      focus: Number(this.intake.step) === 5 && `${this.intake.financeData.step}` === `${i}`,
                    });
                  }
                }
              }
              tempMenu.push({
                id: 8,
                name: 'Risico',
                icon: 'bell',
                valid: false,
                focus: this.intake.step === 8,
              });
              tempMenu.push({
                id: 13,
                name: 'Duurzaamheid',
                icon: 'seedling',
                valid: false,
                focus: this.intake.step === 13,
              });
              tempMenu.push({
                id: 12,
                name: 'Geld overmaken',
                icon: 'exchange-alt',
                valid: false,
                focus: this.intake.step === 12,
              });
            } else if (!this.intake.rekeningData.type && this.intake.goalData.type) {
              tempMenu.push({
                id: 2,
                name: 'Soort rekening',
                icon: 'user',
                valid: false,
                focus: this.intake.step === 2,
              });
            }
            if (this.intake.rekeningData.type && this.intake.persoonsData[0].type) {
              tempMenu.push({
                id: 6,
                name: 'Overzicht',
                icon: 'clipboard-list',
                valid: false,
                focus: this.intake.step === 6,
              });
            }
          }
          if (this.role > 7) {
            if (this.redo) {
              tempMenu.push({
                id: 14,
                name: 'Vergelijken',
                icon: 'compress-alt',
                valid: false,
                focus: this.intake.step === 14,
              });
            }
            tempMenu.push({
              id: 9,
              name: 'Instellingen',
              icon: 'cog',
              valid: false,
              focus: this.intake.step === 9,
            });
            tempMenu.push({
              id: 10,
              name: 'Beleggingsplan',
              icon: 'file-signature',
              valid: false,
              focus: this.intake.step === 10,
            });
          }
          this.activeMenu = findIndex(tempMenu, { focus: true });
          this.menu = tempMenu;
        });
      },
      deep: true,
    },
  },
  computed: {
    getGoalType() {
      if (this.intake.goalData.type === 'studiekinderen') {
        return this.intake.rekeningData.type === 'Particuliere rekening' ? 'Kind(eren) (op uw naam)' : 'Kind (schenken)';
      }
      if (this.intake.goalData.type === 'pensioen') {
        return `${this.intake.goalData.box}` === '1' ? 'Pensioen (box 1)' : 'Pensioen (netto)';
      }
      if (this.intake.goalData.type === 'levensonderhoud') {
        return `${this.intake.goalData.box}` === '1' ? 'Lijfrente (uitkerend)' : 'Levensonderhoud';
      }
      if (this.intake.goalData.type === 'groteaankoop') {
        return 'Grote aankoop';
      }
      if (this.intake.goalData.type === 'hypotheek') {
        return 'Hypotheek';
      }
      if (this.intake.goalData.type === 'vermogensopbouw') {
        return 'Vermogensopbouw';
      }
      if (this.intake.goalData.type === 'gouden-handdruk-opbouwend') {
        return 'Gouden handdruk (opbouwend)';
      }
      if (this.intake.goalData.type === 'gouden-handdruk-uitkerend') {
        return 'Gouden handdruk (uitkerend)';
      }
      if (this.intake.goalData.type === 'netto-lijfrente-opbouwend') {
        return 'Netto lijfrente (opbouwend)';
      }
      if (this.intake.goalData.type === 'netto-lijfrente-uitkerend') {
        return 'Netto lijfrente (uitkerend)';
      }
      return 'Doel';
    },
    overviewErrors() {
      return filter(
        Object.values(this.$store.state.overview),
        (object) => !object,
      ).length;
    },
    isOfferGoal() {
      if (
        (this.intake.goalData.type === 'levensonderhoud' && this.intake.goalData.box === '1')
        || this.intake.goalData.type === 'netto-lijfrente-uitkerend'
        || this.intake.goalData.type === 'gouden-handdruk-uitkerend'
      ) {
        return true;
      }
      return false;
    },
    isOfferMail() {
      if (
        (this.intake.goalData.type === 'pensioen' && this.intake.goalData.box === '1')
        || this.intake.goalData.type === 'gouden-handdruk-opbouwend'
        || (this.intake.goalData.type === 'levensonderhoud' && this.intake.goalData.box === '1')
        || this.intake.goalData.type === 'netto-lijfrente-uitkerend'
        || this.intake.goalData.type === 'gouden-handdruk-uitkerend'
      ) {
        return true;
      }
      return false;
    },
    sustainabilityPopup() {
      if (this.intake.rekeningData.sustainabilityNew) {
        if (this.intake.rekeningData.sustainabilityNew === 'Nee') {
          return 'A';
        }
        if (
          this.intake.rekeningData.sustainabilityNew === 'Ja, niet specifiek'
          || (
            this.intake.rekeningData.sustainabilityEcologicPreference === 'Nee'
            && this.intake.rekeningData.sustainabilityEffect
            && this.intake.rekeningData.sustainabilityEffect !== 'Ja, PAI'
          )
          || (
            this.intake.rekeningData.sustainabilityEcologicPreference === 'Nee'
            && this.intake.rekeningData.sustainabilityEffect === 'Ja, PAI'
            && this.intake.rekeningData.sustainabilityPaiConsider === 'Geen'
          )
        ) {
          return 'B';
        }
        if (this.intake.rekeningData.sustainabilityNew === 'Ja, specifiek') {
          if (
            (
              this.intake.rekeningData.sustainabilityEcologicPreference
              && this.intake.rekeningData.sustainabilityEcologicPreference !== 'Nee'
            )
            || (
              this.intake.rekeningData.sustainabilityEcologicPreference === 'Nee'
              && this.intake.rekeningData.sustainabilityEffect === 'Ja, PAI'
              && this.intake.rekeningData.sustainabilityPaiConsider
              && this.intake.rekeningData.sustainabilityPaiConsider !== 'Geen'
            )
          ) {
            return 'C';
          }
        }
      }
      return '';
    },
    userExtraPorts() {
      return this.extraPorts;
    },
    fields() {
      return Object.keys(this.$store.state.intake).length;
    },
    totalFields() {
      return Math.max(Object.values(this.$store.state.overview).length, 21);
    },
    wrongFields() {
      return filter(Object.values(this.$store.state.overview)).length;
    },
    errors() {
      return filter(this.$store.state.intake, (object) => !object).length;
    },
    role() {
      return this.$store.state.role;
    },
    accountLabels() {
      const accounts = filter(this.users, (v) => v.role > 7);
      const labels = [];
      for (let i = 0; i < accounts.length; i += 1) {
        labels.push({ label: `${accounts[i].name} [${accounts[i].id}]`, value: accounts[i].id.toString() });
      }
      return labels;
    },
    accountLabelsAtp() {
      const accounts = filter(this.users, (v) => v.role > 0);
      const labels = [];
      for (let i = 0; i < accounts.length; i += 1) {
        labels.push({ label: `${accounts[i].name} [${accounts[i].id}]`, value: accounts[i].id.toString() });
      }
      return labels;
    },
    profileLabels() {
      const labels = [];
      for (let i = 0; i < this.profiles.length; i += 1) {
        labels.push({ label: this.profiles[i].name, value: this.profiles[i].name });
      }
      return labels;
    },
  },
  created() {
    this.$store.state.intake = {};
    if (this.role > 7) {
      this.sdk.getUsersQuick((usersResponse) => {
        this.users = usersResponse.data;
      });
      this.sdk.getProfiles((profilesResponse) => {
        this.profiles = profilesResponse.data;
      });
    }
    this.sdk.getIntakePrevious(this.getQueryVariable('intake'), (previousResponse) => {
      if (previousResponse.status === 200 && previousResponse.data.intake) {
        this.previousCompleted = previousResponse.data.complete_date;
        const parsed = JSON.parse(previousResponse.data.intake);
        if (previousResponse.data.redo && !parsed.goalData.doel) {
          parsed.goalData.doel = '0';
        }
        if (!parsed.version) {
          if (typeof parsed.goalData.extrarendement !== 'undefined') {
            parsed.goalData.extrarendement += 0;
          }
          if (parsed.persoonsData) {
            for (let i = 0; i < parsed.persoonsData.length; i += 1) {
              if (typeof parsed.persoonsData[i].hypotheekEigenWoningRente !== 'undefined') {
                parsed.persoonsData[i].hypotheekEigenWoningRente += 0;
              }
              if (typeof parsed.persoonsData[i].hypotheekEigenWoning2Rente !== 'undefined') {
                parsed.persoonsData[i].hypotheekEigenWoning2Rente += 0;
              }
              if (typeof parsed.persoonsData[i].hypotheekEigenWoning3Rente !== 'undefined') {
                parsed.persoonsData[i].hypotheekEigenWoning3Rente += 0;
              }
              if (typeof parsed.persoonsData[i].hypotheekOnroerendGoedRente !== 'undefined') {
                parsed.persoonsData[i].hypotheekOnroerendGoedRente += 0;
              }
              if (typeof parsed.persoonsData[i].hypotheekOnroerendGoed2Rente !== 'undefined') {
                parsed.persoonsData[i].hypotheekOnroerendGoed2Rente += 0;
              }
              if (typeof parsed.persoonsData[i].hypotheekOnroerendGoed2Rente !== 'undefined') {
                parsed.persoonsData[i].hypotheekOnroerendGoed2Rente += 0;
              }
            }
          }
        }
        if (parsed.persoonsData) {
          for (let i = 0; i < parsed.persoonsData.length; i += 1) {
            if (parsed.persoonsData[i].herkomstVermogen) {
              if (parsed.persoonsData[i].herkomstVermogen === 'salaris') {
                parsed.persoonsData[i].herkomstVermogenSalaris = 'Yes';
              }
              if (parsed.persoonsData[i].herkomstVermogen === 'erfenis') {
                parsed.persoonsData[i].herkomstVermogenErfenis = 'Yes';
              }
              if (parsed.persoonsData[i].herkomstVermogen === 'schenking') {
                parsed.persoonsData[i].herkomstVermogenSchenking = 'Yes';
              }
              if (parsed.persoonsData[i].herkomstVermogen === 'woningverkoop') {
                parsed.persoonsData[i].herkomstVermogenWoningverkoop = 'Yes';
              }
              if (parsed.persoonsData[i].herkomstVermogen === 'bedrijfsverkoop') {
                parsed.persoonsData[i].herkomstVermogenBedrijfsverkoop = 'Yes';
              }
              if (parsed.persoonsData[i].herkomstVermogen === 'box1lijfrente') {
                parsed.persoonsData[i].herkomstVermogenBox1lijfrente = 'Yes';
              }
              if (parsed.persoonsData[i].herkomstVermogen === 'box3lijfrente') {
                parsed.persoonsData[i].herkomstVermogenBox3lijfrente = 'Yes';
              }
              if (parsed.persoonsData[i].herkomstVermogen === 'goudenhanddruk') {
                parsed.persoonsData[i].herkomstVermogenGoudenhanddruk = 'Yes';
              }
              if (parsed.persoonsData[i].herkomstVermogen === 'cryptovaluta') {
                parsed.persoonsData[i].herkomstVermogenCryptovaluta = 'Yes';
              }
              if (parsed.persoonsData[i].herkomstVermogen === 'anders') {
                parsed.persoonsData[i].herkomstVermogenAnders = 'Yes';
              }
              delete parsed.persoonsData[i].herkomstVermogen;
            }
            if (parsed.persoonsData[i].anderInkomen === 'Yes'
              && parsed.persoonsData[i].anderInkomenType === 'VerhuurOnroerend'
            ) {
              parsed.persoonsData[i].onroerendgoed = 'Yes';
              parsed.persoonsData[i].onroerendgoedCommercieel = 'Yes';
              parsed.persoonsData[
                i
              ].onroerendgoedBedragPerJaar = parsed.persoonsData[i].anderInkomenPerJaar;
              parsed.persoonsData[i].anderInkomenType = '';
              parsed.persoonsData[i].anderInkomenPerJaar = '';
              parsed.persoonsData[i].anderInkomen = 'No';
            }
          }
        }
        Object.assign(this.previousIntake, parsed, {
          atpData: Object.assign(this.previousIntake.atpData, parsed.atpData),
          persoonsData: Object.assign(this.previousIntake.persoonsData, parsed.persoonsData),
          rekeningData: Object.assign(this.previousIntake.rekeningData, parsed.rekeningData),
          bedrijfsData: Object.assign(this.previousIntake.bedrijfsData, parsed.bedrijfsData),
          goalData: Object.assign(this.previousIntake.goalData, parsed.goalData),
          experienceData: Object.assign(this.previousIntake.experienceData, parsed.experienceData),
          financeData: Object.assign(this.previousIntake.financeData, parsed.financeData),
          transferData: Object.assign(this.previousIntake.transferData, parsed.transferData),
        });
        if (this.previousIntake.transferData.overdrachten
          && this.previousIntake.transferData.overdrachten.length > 0) {
          for (let i = 0; i < this.previousIntake.transferData.overdrachten.length; i += 1) {
            if (this.previousIntake.transferData.overdrachten[i].overdrachtType !== 'bv'
              && this.previousIntake.transferData.overdrachten[i].instellingNaam) {
              if (filter(
                this.bankNames,
                { value: this.previousIntake.transferData.overdrachten[i].instellingNaam },
              ).length === 0) {
                this.previousIntake.transferData.overdrachten[
                  i
                ].instellingNaamOmschrijving = this.previousIntake.transferData.overdrachten[
                  i
                ].instellingNaam;
                this.previousIntake.transferData.overdrachten[i].instellingNaam = 'Anders';
              }
            }
          }
        }

        if (this.previousIntake.bedrijfsData.rechtsvorm) {
          if (!this.rechtsvormen.some(
            (o) => o.value.toLowerCase()
            === this.previousIntake.bedrijfsData.rechtsvorm.toLowerCase(),
          )) {
            this.previousIntake.bedrijfsData.rechtsvormAnders = this.previousIntake
              .bedrijfsData.rechtsvorm;
            this.previousIntake.bedrijfsData.rechtsvorm = 'anders';
          } else {
            this.previousIntake.bedrijfsData.rechtsvorm = this.previousIntake.bedrijfsData
              .rechtsvorm.toLowerCase();
          }
        }
      }
      Object.assign(this.previousIntakeAdmin, JSON.parse(previousResponse.data.admin || '{}'));
      this.previousEmail = previousResponse.data.email;
      this.previousId = previousResponse.data.id;
      this.sdk.getIntake(this.getQueryVariable('intake'), (response) => {
        if (response.status === 200) {
          const parsedAdmin = JSON.parse(response.data.admin || '{}');
          if (response.data.intake) {
            if (Number(response.data.client) !== Number(this.$store.state.client) && response.data.status === 'Bezig') {
              if (this.role < 8) {
                // eslint-disable-next-line
                alert('U zit in leesmodus, om te kunnen schrijven klik in het menu op leesmodus om te wisselen naar schrijfmodus. Let op dat u dan gegevens kan overschrijven die de klant op dit moment aan het invullen is. Ga daarom snel uit de intake of schrijfmodus wanneer u klaar bent.');
              }
              this.writeModus = false;
            }
            const parsed = JSON.parse(response.data.intake);
            if (!parsed.utm && this.role < 5) {
              const utmCookieRaw = this.readCookie('utmcookie');
              if (utmCookieRaw) {
                try {
                  parsed.utm = JSON.parse(utmCookieRaw);
                } catch (e) {
                  parsed.utm = { utm_source: utmCookieRaw };
                }
              }
            }
            if (response.data.redo && !parsed.goalData.doel) {
              parsed.goalData.doel = '0';
            }
            if (parsed.goalData.type && parsed.goalData.step === 1) {
              parsed.goalData.step = 2;
            }
            if (parsed.goalData.type === 'gouden-handdruk-opbouwend') {
              parsed.goalData.stortingenBedrag = '0';
            }
            if (parsed.persoonsData) {
              for (let i = 0; i < parsed.persoonsData.length; i += 1) {
                if (parsed.persoonsData[i].nationaliteit === 'Nederland') {
                  parsed.persoonsData[i].dutchNationality = 'Yes';
                }
              }
            }
            if (!parsed.version) {
              if (typeof parsed.goalData.extrarendement !== 'undefined') {
                parsed.goalData.extrarendement += 0;
              }
              if (parsed.persoonsData) {
                for (let i = 0; i < parsed.persoonsData.length; i += 1) {
                  if (typeof parsed.persoonsData[i].hypotheekEigenWoningRente !== 'undefined') {
                    parsed.persoonsData[i].hypotheekEigenWoningRente += 0;
                  }
                  if (typeof parsed.persoonsData[i].hypotheekEigenWoning2Rente !== 'undefined') {
                    parsed.persoonsData[i].hypotheekEigenWoning2Rente += 0;
                  }
                  if (typeof parsed.persoonsData[i].hypotheekEigenWoning3Rente !== 'undefined') {
                    parsed.persoonsData[i].hypotheekEigenWoning3Rente += 0;
                  }
                  if (typeof parsed.persoonsData[i].hypotheekOnroerendGoedRente !== 'undefined') {
                    parsed.persoonsData[i].hypotheekOnroerendGoedRente += 0;
                  }
                  if (typeof parsed.persoonsData[i].hypotheekOnroerendGoed2Rente !== 'undefined') {
                    parsed.persoonsData[i].hypotheekOnroerendGoed2Rente += 0;
                  }
                  if (typeof parsed.persoonsData[i].hypotheekOnroerendGoed2Rente !== 'undefined') {
                    parsed.persoonsData[i].hypotheekOnroerendGoed2Rente += 0;
                  }
                }
              }
            }
            if (parsed.persoonsData) {
              for (let i = 0; i < parsed.persoonsData.length; i += 1) {
                if (
                  parsed.persoonsData[i].geboorteDag
                  && parsed.persoonsData[i].geboorteMaand
                  && parsed.persoonsData[i].geboorteJaar
                ) {
                  // create padded month through ISO
                  const Datum = new Date(
                    parsed.persoonsData[i].geboorteJaar,
                    parsed.persoonsData[i].geboorteMaand - 1,
                    parsed.persoonsData[i].geboorteDag,
                    12,
                  ).toISOString();
                  parsed.persoonsData[i].geboorteDatum = Datum;
                  delete parsed.persoonsData[i].geboorteDag;
                  delete parsed.persoonsData[i].geboorteMaand;
                  delete parsed.persoonsData[i].geboorteJaar;
                }
                if (parsed.persoonsData[i].geboorteDatum && parsed.persoonsData[i].geboorteDatum.indexOf('T') === -1) {
                  parsed.persoonsData[i].geboorteDatum = `${parsed.persoonsData[i].geboorteDatum}T12:00:00.000Z`;
                }
                if (parsed.persoonsData[i].herkomstVermogen) {
                  if (parsed.persoonsData[i].herkomstVermogen === 'salaris') {
                    parsed.persoonsData[i].herkomstVermogenSalaris = 'Yes';
                  }
                  if (parsed.persoonsData[i].herkomstVermogen === 'erfenis') {
                    parsed.persoonsData[i].herkomstVermogenErfenis = 'Yes';
                  }
                  if (parsed.persoonsData[i].herkomstVermogen === 'schenking') {
                    parsed.persoonsData[i].herkomstVermogenSchenking = 'Yes';
                  }
                  if (parsed.persoonsData[i].herkomstVermogen === 'woningverkoop') {
                    parsed.persoonsData[i].herkomstVermogenWoningverkoop = 'Yes';
                  }
                  if (parsed.persoonsData[i].herkomstVermogen === 'bedrijfsverkoop') {
                    parsed.persoonsData[i].herkomstVermogenBedrijfsverkoop = 'Yes';
                  }
                  if (parsed.persoonsData[i].herkomstVermogen === 'box1lijfrente') {
                    parsed.persoonsData[i].herkomstVermogenBox1lijfrente = 'Yes';
                  }
                  if (parsed.persoonsData[i].herkomstVermogen === 'box3lijfrente') {
                    parsed.persoonsData[i].herkomstVermogenBox3lijfrente = 'Yes';
                  }
                  if (parsed.persoonsData[i].herkomstVermogen === 'goudenhanddruk') {
                    parsed.persoonsData[i].herkomstVermogenGoudenhanddruk = 'Yes';
                  }
                  if (parsed.persoonsData[i].herkomstVermogen === 'cryptovaluta') {
                    parsed.persoonsData[i].herkomstVermogenCryptovaluta = 'Yes';
                  }
                  if (parsed.persoonsData[i].herkomstVermogen === 'anders') {
                    parsed.persoonsData[i].herkomstVermogenAnders = 'Yes';
                  }
                  delete parsed.persoonsData[i].herkomstVermogen;
                }
                if (parsed.persoonsData[i].anderInkomen === 'Yes'
                  && parsed.persoonsData[i].anderInkomenType === 'VerhuurOnroerend'
                ) {
                  parsed.persoonsData[i].onroerendgoed = 'Yes';
                  parsed.persoonsData[i].onroerendgoedCommercieel = 'Yes';
                  parsed.persoonsData[
                    i
                  ].onroerendgoedBedragPerJaar = parsed.persoonsData[i].anderInkomenPerJaar;
                  parsed.persoonsData[i].anderInkomenType = '';
                  parsed.persoonsData[i].anderInkomenPerJaar = '';
                  parsed.persoonsData[i].anderInkomen = 'No';
                }
                // oude rente type fix
                if (parsed.persoonsData[i].hypotheekEigenWoningRenteType === 'vaste') {
                  parsed.persoonsData[i].hypotheekEigenWoningRenteType = 'vast';
                }
                if (parsed.persoonsData[i].hypotheekEigenWoning2RenteType === 'vaste') {
                  parsed.persoonsData[i].hypotheekEigenWoning2RenteType = 'vast';
                }
                if (parsed.persoonsData[i].hypotheekEigenWoning3RenteType === 'vaste') {
                  parsed.persoonsData[i].hypotheekEigenWoning3RenteType = 'vast';
                }
                if (parsed.persoonsData[i].hypotheekOnroerendGoedRenteType === 'vaste') {
                  parsed.persoonsData[i].hypotheekOnroerendGoedRenteType = 'vast';
                }
                if (parsed.persoonsData[i].hypotheekOnroerendGoed2RenteType === 'vaste') {
                  parsed.persoonsData[i].hypotheekOnroerendGoed2RenteType = 'vast';
                }
                if (parsed.persoonsData[i].hypotheekOnroerendGoed3RenteType === 'vaste') {
                  parsed.persoonsData[i].hypotheekOnroerendGoed3RenteType = 'vast';
                }

                // set first savings question for first person to yes
                if (i === 0) {
                  parsed.persoonsData[i].spaarrekening = 'Yes';
                }
              }
            }
            if (parsed.rekeningData) {
              if (parsed.rekeningData.sustainabilityPreference) {
                parsed.rekeningData.acceptSustainabilityText = 'Yes';
                if (parsed.rekeningData.sustainabilityPreference === 'Yes') {
                  parsed.rekeningData.sustainability = 'A';
                } else {
                  parsed.rekeningData.sustainability = 'C';
                }
                delete parsed.rekeningData.sustainabilityPreference;
              }
              if (parsedAdmin.beleggen.brand === 'Doelbeleggen' && parsed.rekeningData.sustainability) {
                if (parsed.rekeningData.sustainability === 'A') {
                  parsed.rekeningData.sustainabilityNew = 'Ja, specifiek';
                } else if (parsed.rekeningData.sustainability === 'B') {
                  parsed.rekeningData.sustainabilityNew = 'Nee';
                } else {
                  parsed.rekeningData.sustainabilityNew = 'Ja, niet specifiek';
                }
                delete parsed.rekeningData.sustainability;
              }
            }
            if (parsed.pastPeriodExperience && parsed.goalData) {
              if (parsed.pastPeriodExperience === 'Yes') {
                parsed.goalData.pastPeriodExperience = 'A';
              } else {
                parsed.goalData.pastPeriodExperience = 'B';
              }
              delete parsed.pastPeriodExperience;
            }

            Object.assign(this.intake, parsed, {
              atpData: Object.assign(this.intake.atpData, parsed.atpData),
              persoonsData: Object.assign(this.intake.persoonsData, parsed.persoonsData),
              rekeningData: Object.assign(this.intake.rekeningData, parsed.rekeningData),
              bedrijfsData: Object.assign(this.intake.bedrijfsData, parsed.bedrijfsData),
              goalData: Object.assign(this.intake.goalData, parsed.goalData),
              experienceData: Object.assign(this.intake.experienceData, parsed.experienceData),
              financeData: Object.assign(this.intake.financeData, parsed.financeData),
              transferData: Object.assign(this.intake.transferData, parsed.transferData),
            });
            this.intake.advisorDetails = {};
            this.sdk.getAtpDetailsForUser(
              parsedAdmin.beleggen.sales,
              (atpResponse) => {
                if (atpResponse.status === 200) {
                  if (atpResponse.data.length) {
                    this.intake.advisorDetails = { ...atpResponse.data[0] };
                  }
                }
              },
            );

            if (this.intake.transferData.overdrachten
              && this.intake.transferData.overdrachten.length > 0) {
              for (let i = 0; i < this.intake.transferData.overdrachten.length; i += 1) {
                if (this.intake.transferData.overdrachten[i].overdrachtType !== 'bv'
                  && this.intake.transferData.overdrachten[i].instellingNaam) {
                  if (filter(
                    this.bankNames,
                    { value: this.intake.transferData.overdrachten[i].instellingNaam },
                  ).length === 0) {
                    this.intake.transferData.overdrachten[
                      i
                    ].instellingNaamOmschrijving = this.intake.transferData.overdrachten[
                      i
                    ].instellingNaam;
                    this.intake.transferData.overdrachten[i].instellingNaam = 'Anders';
                  }
                }
              }
            }
          }
          Object.assign(this.intakeAdmin, parsedAdmin, {
            beleggen: Object.assign(this.intakeAdmin.beleggen, parsedAdmin.beleggen),
          });

          // Set contact frequence default for VMVB and BVS
          if (
            this.intakeAdmin.beleggen.brand === 'VMVB'
            || this.intakeAdmin.beleggen.brand === 'BVS'
          ) {
            if (!this.intakeAdmin.beleggen.contact) {
              if (
                Number(this.intake.goalData.vermogen) > 0
                && Number(this.intake.goalData.vermogen <= 100000)
              ) {
                this.intakeAdmin.beleggen.contact = '1p12mnd';
              } else if (Number(this.intake.goalData.vermogen <= 250000)) {
                this.intakeAdmin.beleggen.contact = '1p6mnd';
              } else {
                this.intakeAdmin.beleggen.contact = '1p3mnd';
              }
            }
          }

          if (this.intakeAdmin.beleggen.fee) {
            if (this.intakeAdmin.beleggen.fee === 'flat') {
              this.intakeAdmin.beleggen.feeName = 'vmbvs';
            } else if (this.intakeAdmin.beleggen.fee === 'vm-giro') {
              this.intakeAdmin.beleggen.feeName = 'vmgiro';
            } else if (this.intakeAdmin.beleggen.fee === 'doelbeleggen') {
              this.intakeAdmin.beleggen.feeName = 'db';
            } else if (this.intakeAdmin.beleggen.fee === 'doelbeleggen-friends') {
              this.intakeAdmin.beleggen.feeName = 'dbvriendenfamilie';
            } else if (this.intakeAdmin.beleggen.fee === 'doelbeleggen-employees') {
              this.intakeAdmin.beleggen.feeName = 'werknemer';
            } else if (this.intakeAdmin.beleggen.fee === 'doelbeleggen-veh') {
              this.intakeAdmin.beleggen.feeName = 'dbverenigingeigenhuis';
            } else if (this.intakeAdmin.beleggen.fee === 'oxby') {
              this.intakeAdmin.beleggen.feeName = 'oxby';
            } else if (this.intakeAdmin.beleggen.fee === 'oxby-friends') {
              this.intakeAdmin.beleggen.feeName = 'oxbyvriendenfamilie';
            } else if (this.intakeAdmin.beleggen.fee === 'oxby-employees') {
              this.intakeAdmin.beleggen.feeName = 'werknemer';
            } else if (
              this.intakeAdmin.beleggen.fee === 'dbatpopbouwend'
              || this.intakeAdmin.beleggen.fee === 'dbatpuitkerend'
              || this.intakeAdmin.beleggen.fee === 'dbatp'
            ) {
              this.intakeAdmin.beleggen.feeName = this.intakeAdmin.beleggen.fee;
            } else {
              this.intakeAdmin.beleggen.feeName = 'custom';
            }
            delete this.intakeAdmin.beleggen.fee;
            Object.assign(
              this.intakeAdmin.beleggen,
              filter(this.feeList, {
                feeName: this.intakeAdmin.beleggen.feeName,
              })[0],
            );
          } else if (!this.intakeAdmin.beleggen.feeName) {
            if (this.intakeAdmin.beleggen.brand === 'Doelbeleggen') {
              this.intakeAdmin.beleggen.feeName = 'db';
            } else if (this.intakeAdmin.beleggen.brand === 'OXBY') {
              this.intakeAdmin.beleggen.feeName = 'oxby';
            } else {
              this.intakeAdmin.beleggen.feeName = 'vmbvs';
            }
            Object.assign(
              this.intakeAdmin.beleggen,
              filter(this.feeList, {
                feeName: this.intakeAdmin.beleggen.feeName,
              })[0],
            );
          }
          try {
            JSON.parse(this.intakeAdmin.status);
          } catch (e) {
            this.intakeAdmin.status = '{}';
          }
          if (!this.intakeAdmin.cdd) {
            this.intakeAdmin.cdd = {};
          }

          for (let i = 0; i < this.intake.persoonsData.length; i += 1) {
            // Set commercial real estate to auto answer
            if (
              this.financeFilter(this.intake.persoonsData[i])
              && response.data.status === 'Ingeleverd'
              && (!this.intakeAdmin.cdd[`${i}-commercialrealestate`]
              || !this.intakeAdmin.cdd[`${i}-commercialrealestate`].answer)
            ) {
              if (!this.intakeAdmin.cdd[`${i}-commercialrealestate`]) {
                this.intakeAdmin.cdd[`${i}-commercialrealestate`] = {};
              }
              this.intakeAdmin.cdd[
                `${i}-commercialrealestate`
              ].answer = this.intake.persoonsData[i].onroerendgoed === 'Yes'
                && this.intake.persoonsData[i].onroerendgoedCommercieel === 'Yes'
                && (
                  Number(this.intake.persoonsData[i].onroerendgoedVrijeverkoopwaarde) >= 3000000
                  || Number(this.intake.persoonsData[i].onroerendgoedObjecten) > 4
                )
                ? 'Hoog risico'
                : 'Laag risico';
              this.intakeAdmin.cdd[`${i}-commercialrealestate`].user = 'Automatisch';
              this.intakeAdmin.cdd[`${i}-commercialrealestate`].date = new Date();
              this.intakeAdmin.cdd[
                `${i}-commercialrealestate`
              ].state = this.intake.persoonsData[i].onroerendgoed === 'Yes'
                && this.intake.persoonsData[i].onroerendgoedCommercieel === 'Yes'
                && (
                  Number(this.intake.persoonsData[i].onroerendgoedVrijeverkoopwaarde) >= 3000000
                  || Number(this.intake.persoonsData[i].onroerendgoedObjecten) > 4
                )
                ? 'warning'
                : 'valid';
            }
            // set wealth origin to auto answer
            if (this.financeFilter(this.intake.persoonsData[i])
              && response.data.status === 'Ingeleverd'
              && this.intake.goalData.box !== '1') {
              if (this.intakeAdmin.cdd[`${i}-wealthorigin`]
                && this.intakeAdmin.cdd[`${i}-wealthorigin`].answer
                && this.intakeAdmin.cdd[`${i}-wealthorigin`].state) {
                if (this.intake.persoonsData[i].herkomstVermogenSalaris === 'Yes') {
                  this.intakeAdmin.cdd[`${i}-wealthoriginsalary`] = {
                    answer: this.intakeAdmin.cdd[`${i}-wealthorigin`].answer,
                    state: this.intakeAdmin.cdd[`${i}-wealthorigin`].state,
                    user: this.intakeAdmin.cdd[`${i}-wealthorigin`].user,
                    date: this.intakeAdmin.cdd[`${i}-wealthorigin`].date,
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenErfenis === 'Yes') {
                  this.intakeAdmin.cdd[`${i}-wealthoriginheritage`] = {
                    answer: this.intakeAdmin.cdd[`${i}-wealthorigin`].answer,
                    state: this.intakeAdmin.cdd[`${i}-wealthorigin`].state,
                    user: this.intakeAdmin.cdd[`${i}-wealthorigin`].user,
                    date: this.intakeAdmin.cdd[`${i}-wealthorigin`].date,
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenSchenking === 'Yes') {
                  this.intakeAdmin.cdd[`${i}-wealthorigindonation`] = {
                    answer: this.intakeAdmin.cdd[`${i}-wealthorigin`].answer,
                    state: this.intakeAdmin.cdd[`${i}-wealthorigin`].state,
                    user: this.intakeAdmin.cdd[`${i}-wealthorigin`].user,
                    date: this.intakeAdmin.cdd[`${i}-wealthorigin`].date,
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenWoningverkoop === 'Yes') {
                  this.intakeAdmin.cdd[`${i}-wealthoriginhousesales`] = {
                    answer: this.intakeAdmin.cdd[`${i}-wealthorigin`].answer,
                    state: this.intakeAdmin.cdd[`${i}-wealthorigin`].state,
                    user: this.intakeAdmin.cdd[`${i}-wealthorigin`].user,
                    date: this.intakeAdmin.cdd[`${i}-wealthorigin`].date,
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenBedrijfsverkoop === 'Yes') {
                  this.intakeAdmin.cdd[`${i}-wealthorigincompanysales`] = {
                    answer: this.intakeAdmin.cdd[`${i}-wealthorigin`].answer,
                    state: this.intakeAdmin.cdd[`${i}-wealthorigin`].state,
                    user: this.intakeAdmin.cdd[`${i}-wealthorigin`].user,
                    date: this.intakeAdmin.cdd[`${i}-wealthorigin`].date,
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenBox1lijfrente === 'Yes') {
                  this.intakeAdmin.cdd[`${i}-wealthoriginbox1annuity`] = {
                    answer: this.intakeAdmin.cdd[`${i}-wealthorigin`].answer,
                    state: this.intakeAdmin.cdd[`${i}-wealthorigin`].state,
                    user: this.intakeAdmin.cdd[`${i}-wealthorigin`].user,
                    date: this.intakeAdmin.cdd[`${i}-wealthorigin`].date,
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenBox3lijfrente === 'Yes') {
                  this.intakeAdmin.cdd[`${i}-wealthoriginbox3annuity`] = {
                    answer: this.intakeAdmin.cdd[`${i}-wealthorigin`].answer,
                    state: this.intakeAdmin.cdd[`${i}-wealthorigin`].state,
                    user: this.intakeAdmin.cdd[`${i}-wealthorigin`].user,
                    date: this.intakeAdmin.cdd[`${i}-wealthorigin`].date,
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenGoudenhanddruk === 'Yes') {
                  this.intakeAdmin.cdd[`${i}-wealthorigingoldenhandshake`] = {
                    answer: this.intakeAdmin.cdd[`${i}-wealthorigin`].answer,
                    state: this.intakeAdmin.cdd[`${i}-wealthorigin`].state,
                    user: this.intakeAdmin.cdd[`${i}-wealthorigin`].user,
                    date: this.intakeAdmin.cdd[`${i}-wealthorigin`].date,
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenCryptovaluta === 'Yes') {
                  this.intakeAdmin.cdd[`${i}-wealthorigincrypto`] = {
                    answer: this.intakeAdmin.cdd[`${i}-wealthorigin`].answer,
                    state: this.intakeAdmin.cdd[`${i}-wealthorigin`].state,
                    user: this.intakeAdmin.cdd[`${i}-wealthorigin`].user,
                    date: this.intakeAdmin.cdd[`${i}-wealthorigin`].date,
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenAnders === 'Yes') {
                  this.intakeAdmin.cdd[`${i}-wealthorigindifferent`] = {
                    answer: this.intakeAdmin.cdd[`${i}-wealthorigin`].answer,
                    state: this.intakeAdmin.cdd[`${i}-wealthorigin`].state,
                    user: this.intakeAdmin.cdd[`${i}-wealthorigin`].user,
                    date: this.intakeAdmin.cdd[`${i}-wealthorigin`].date,
                  };
                }
                delete this.intakeAdmin.cdd[`${i}-wealthorigin`];
              } else {
                if (this.intake.persoonsData[i].herkomstVermogenSalaris === 'Yes'
                  && (!this.intakeAdmin.cdd[`${i}-wealthoriginsalary`]
                    || !this.intakeAdmin.cdd[`${i}-wealthoriginsalary`].answer
                  )
                ) {
                  this.intakeAdmin.cdd[`${i}-wealthoriginsalary`] = {
                    answer: 'Laag risico',
                    state: 'valid',
                    user: 'Automatisch',
                    date: new Date(),
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenBox1lijfrente === 'Yes'
                  && (!this.intakeAdmin.cdd[`${i}-wealthoriginbox1annuity`]
                    || !this.intakeAdmin.cdd[`${i}-wealthoriginbox1annuity`].answer
                  )
                ) {
                  this.intakeAdmin.cdd[`${i}-wealthoriginbox1annuity`] = {
                    answer: 'Laag risico',
                    state: 'valid',
                    user: 'Automatisch',
                    date: new Date(),
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenBox3lijfrente === 'Yes'
                  && (!this.intakeAdmin.cdd[`${i}-wealthoriginbox3annuity`]
                    || !this.intakeAdmin.cdd[`${i}-wealthoriginbox3annuity`].answer
                  )
                ) {
                  this.intakeAdmin.cdd[`${i}-wealthoriginbox3annuity`] = {
                    answer: 'Laag risico',
                    state: 'valid',
                    user: 'Automatisch',
                    date: new Date(),
                  };
                }
                if (this.intake.persoonsData[i].herkomstVermogenCryptovaluta === 'Yes'
                  && (!this.intakeAdmin.cdd[`${i}-wealthorigincrypto`]
                    || !this.intakeAdmin.cdd[`${i}-wealthorigincrypto`].answer
                  )
                ) {
                  this.intakeAdmin.cdd[`${i}-wealthorigincrypto`] = {
                    answer: 'Hoog risico',
                    state: 'warning',
                    reason: 'Automatisch berekend',
                    user: 'Automatisch',
                    date: new Date(),
                  };
                }
              }
            }
            // Set Type of income to auto answer
            if (this.financeFilter(this.intake.persoonsData[i])
              && response.data.status === 'Ingeleverd'
              && (!this.intakeAdmin.cdd[`${i}-typeofincome`]
              || !this.intakeAdmin.cdd[`${i}-typeofincome`].answer)
            ) {
              if (this.intake.persoonsData[i].inkomenType === 'Eenmanszaak'
                || this.intake.persoonsData[i].inkomenType === 'Zelfstandige') {
                this.intakeAdmin.cdd[`${i}-typeofincome`] = {
                  answer: 'Hoog risico',
                  state: 'warning',
                  reason: 'Automatisch berekend',
                  user: 'Automatisch',
                  date: new Date(),
                };
              } else if (this.intake.persoonsData[i].inkomenType === 'Loondienst'
                || this.intake.persoonsData[i].inkomenType === 'Pensioen') {
                this.intakeAdmin.cdd[`${i}-typeofincome`] = {
                  answer: 'Laag risico',
                  state: 'valid',
                  user: 'Automatisch',
                  date: new Date(),
                };
              }
            }

            // Set geboorteland (if NL) to auto
            if (response.data.status === 'Ingeleverd'
            && (!this.intakeAdmin.cdd[`${i}-countryofbirth`]
            || !this.intakeAdmin.cdd[`${i}-countryofbirth`].answer)
            && this.intake.persoonsData[i].geboorteland === 'Nederland') {
              this.intakeAdmin.cdd[`${i}-countryofbirth`] = {
                answer: 'Laag risico',
                state: 'valid',
                user: 'Automatisch',
                date: new Date(),
              };
            }

            // Set sector to auto
            if (this.financeFilter(this.intake.persoonsData[i])
              && response.data.status === 'Ingeleverd'
              && (!this.intakeAdmin.cdd[`${i}-sector`]
                || !this.intakeAdmin.cdd[`${i}-sector`].answer
              )
            ) {
              if (this.intake.persoonsData[i].sector !== 'geen-van-bovenstaande'
                && this.intake.persoonsData[i].branche !== 'anders'
                && this.intake.persoonsData[i].arbeidsSituatie !== 'Anders'
              ) {
                if (
                  // For all high risk
                  [
                    'fin-crypto-ico', 'handel-crypto-ico', 'handel-militair',
                    'ict-crypto-ico', 'ict-gamen-gokken', 'ind-seksind',
                    'kunst-seksind', 'zak-com-shop', 'zak-com-militair',
                    'zak-com-seksind', 'zak-com-trust', 'handel-juwelen',
                  ].includes(this.intake.persoonsData[i].sector)
                  || ['sport', 'zorg', 'cash', 'horeca'].includes(this.intake.persoonsData[i].branche)
                  // For high risks + not employee
                  || (this.intake.persoonsData[i].arbeidsSituatie !== 'Werknemer'
                    && (
                      ['ict-p2p', 'zak-com-vastgoed'].includes(this.intake.persoonsData[i].sector)
                      || [
                        'bouw', 'handel', 'vastgoed',
                        'char', 'kerk', 'gok',
                      ].includes(this.intake.persoonsData[i].branche)
                    )
                  )
                  // For high risks + not employee + not higher management
                  || (this.intake.persoonsData[i].arbeidsSituatie !== 'Werknemer'
                    && this.intake.persoonsData[i].arbeidsSituatie !== 'Hoger management'
                    && (
                      [
                        'ind-afval', 'ind-farma', 'ind-grondstoffen',
                        'ind-olie-gas', 'ind-water', 'zak-com-afval',
                        'zak-com-juwel', 'zak-com-opslag', 'zak-com-veiling',
                        'zak-com-water',
                      ].includes(this.intake.persoonsData[i].sector)
                      || [
                        'fin', 'ict', 'kunst', 'overheid',
                        'landbouw', 'farma', 'ver',
                      ].includes(this.intake.persoonsData[i].branche)
                    )
                  )
                ) {
                  this.intakeAdmin.cdd[`${i}-sector`] = {
                    answer: 'Hoog risico',
                    state: 'warning',
                    reason: 'Automatisch berekend',
                    user: 'Automatisch',
                    date: new Date(),
                  };
                } else {
                  this.intakeAdmin.cdd[`${i}-sector`] = {
                    answer: 'Laag risico',
                    state: 'valid',
                    user: 'Automatisch',
                    date: new Date(),
                  };
                }
              }
            }

            if (this.financeFilter(this.intake.persoonsData[i])
              && response.data.status === 'Ingeleverd') {
              // Save AFM sector
              this.intakeAdmin[`afmSectorQualification${i}`] = this.afmQualification(
                this.intake.persoonsData[i],
              );
            }

            if (this.intakeAdmin.cdd[`${i}-bankregistration`] && !this.intakeAdmin.cdd.bankregistration) {
              this.intakeAdmin.cdd.bankregistration = this.intakeAdmin.cdd[`${i}-bankregistration`];
            }
          }

          this.$store.state.cdd = this.intakeAdmin.cdd;
          if (!this.intakeAdmin.showstoppers) {
            this.intakeAdmin.showstoppers = {};
          }
          this.$store.state.showstoppers = this.intakeAdmin.showstoppers;
          this.userOverview = {
            create_date: response.data.date,
            create_client: response.data.create_client,
            send_date: response.data.send_date,
            send_client: response.data.send_client,
            accept_date: response.data.accept_date,
            accept_client: response.data.accept_client,
            sign_date: response.data.sign_date,
            sign_client: response.data.sign_client,
            complete_date: response.data.complete_date,
            complete_client: response.data.complete_client,
            documents_check_date: response.data.documents_check_date,
            documents_check_client: response.data.documents_check_client,
          };

          if (
            !this.intake.goalData.defaults
            && !response.data.redo
            && !this.intake.goalData.vermogen
          ) {
            this.setDefaults();
            this.intake.goalData.defaults = true;
          }

          this.loaded = true;
          this.completeDate = response.data.complete_date
            ? new Date(response.data.complete_date)
            : new Date();
          this.status = response.data.status;
          this.redo = response.data.redo;
          this.files = response.data.files;
          this.created = response.data.date;
          this.port = response.data.port;
          this.id = response.data.id;
          this.value = response.data.value;
          this.email = response.data.email;
          this.client = response.data.client;

          if (this.role > 7) {
            this.sdk.getUsers((userResponse) => {
              for (let i = 0; i < userResponse.data.results[0].ports.length; i += 1) {
                if (userResponse.data.results[0].ports[i].id !== this.port
                  && Number(userResponse.data.results[0].ports[i].status) !== 3) {
                  this.extraPorts.push(userResponse.data.results[0].ports[i].id);
                }
              }
            }, `email eq ${this.email}`, 0, 1);
          }

          if (this.redo) {
            this.sdk.getPort(
              this.port,
              (posResponse) => {
                if (posResponse.status === 200) {
                  this.portValue = posResponse.data.value;
                  if (posResponse.data.cashflow.length > 0) {
                    this.cashflowDate = posResponse.data.cashflow[0].start_date;
                  }
                  this.name = posResponse.data.name;
                  if (!this.intake.goalData.targetDate) {
                    this.intake.goalData.targetDate = posResponse.data.target_date;
                  }
                }
              },
            );
            this.$store.state.intakeValidate = true;
            this.intake.step = 6;
          }

          if (Number(this.getQueryVariable('offer')) === 1) {
            this.intake.step = 1;
            this.intake.goalData.step = 2;
            this.$nextTick(() => {
              if (
                this.intake.goalData.box === '1'
                && (
                  this.intake.goalData.type === 'pensioen'
                  || this.intake.goalData.type === 'gouden-handdruk-opbouwend'
                )
              ) {
                this.$refs.goalpage.offerDepositModal = true;
              } else if (filter(this.intake.offers, (o) => !o.deleted)) {
                if (filter(this.intake.offers, (o) => o.selected).length === 0) {
                  this.$refs.goalpage.offerAdminIndex = filter(
                    this.intake.offers,
                    (o) => !o.deleted,
                  )[0].offerId;
                  this.$refs.goalpage.offerUserModal = true;
                } else {
                  this.$refs.goalpage.offerUserModal = false;
                }
              }
            });
          }

          if (this.previousIntake.bedrijfsData.rechtsvorm) {
            if (!this.rechtsvormen.some(
              (o) => o.value.toLowerCase() === this.intake.bedrijfsData.rechtsvorm.toLowerCase(),
            )) {
              this.intake.bedrijfsData.rechtsvormAnders = this.intake.bedrijfsData.rechtsvorm;
              this.intake.bedrijfsData.rechtsvorm = 'anders';
            } else {
              this.intake.bedrijfsData.rechtsvorm = this.intake.bedrijfsData
                .rechtsvorm.toLowerCase();
            }
          }

          let subId = null;
          if (this.intake.step === 2) {
            subId = this.intake.rekeningData.step;
          } else if (this.intake.step === 5) {
            subId = this.intake.financeData.step;
          }

          window.history.pushState({
            step: this.intake.step,
            subStep: subId,
          }, 'step');

          if (
            (this.role < 8 && (Number(this.intake.step) === 9 || Number(this.intake.step) === 10))
            || (!(Number(this.role) === 2 || Number(this.role) > 7)
              && Number(this.intake.step) === 15
            )
          ) {
            this.storeIntake(6);
          }
        } else {
          window.onbeforeunload = () => {};
          window.location.href = '?';
        }
      });
    });
    window.onpopstate = (event) => {
      if (event.state) {
        this.intake.step = event.state.step;
        if (this.intake.step === 2) {
          this.intake.rekeningData.step = event.state.subStep;
        }
        if (this.intake.step === 5) {
          this.intake.financeData.step = event.state.subStep;
        }
      }
    };
    window.onbeforeunload = (e) => {
      e.returnValue = 'Weet u zeker dat u dit scherm wilt sluiten?';
      return 'Weet u zeker dat u dit scherm wilt sluiten?';
    };
  },
  methods: {
    changingCollect() {
      if (this.redo
        && this.intake.goalData.collect === 'Yes'
        && this.previousIntake.goalData.collect === 'No'
        && this.previousIntake.acceptCollectTerms === 'Yes'
      ) {
        delete this.intake.acceptCollectTerms;
      }
    },
    goToClientConnect() {
      this.intake.step = 15;
    },
    sendProfile() {
      this.$store.state.confirm.toggle({
        text: `U wilt uw klantprofiel verlaten, ${
          Number(this.overviewErrors) === 0
            ? ` maar u heeft uw wijzigingen in uw klantprofiel nog niet definitief gemaakt. Dit kunt
            u doen door op de knop 'Versturen' te klikken in het overzicht van uw klantprofiel.`
            : ` maar nog niet alle vragen zijn beantwoord. In het overzicht kunt u zien welke vragen
            dat zijn. Als alles is beantwoord, kunt u op de knop 'Versturen' klikken in het
            overzicht.`
        }`,
        confirmText: 'Overzicht',
        cancelText: 'Verlaat',
        cb: (confirmed) => {
          if (confirmed) {
            this.intake.step = 6;
          } else {
            this.quitIntake();
          }
        },
      });
    },
    checkPlanErrors(check) {
      const errorArray = [];
      const keys = Object.keys(this.$store.state.showstoppersErrors);
      for (let i = 0; i < keys.length; i += 1) {
        if (keys[i].startsWith(check)) {
          errorArray.push(keys[i]);
        }
      }
      return errorArray.length;
    },
    afmQualification(user) {
      let quali = '?';
      if (user.sector === 'zak-com-trust') {
        quali = 'Trustkantoren(9)';
      } else if (
        user.sector === 'fin-crypto-ico'
        || user.sector === ' handel-crypto-ico'
        || user.sector === 'ict-crypto-ico'
      ) {
        quali = 'Virtuele valuta(inclusief het minen, wisselen etc.)(11)';
      } else if (
        user.sector === 'handel-juwelen'
        || user.sector === 'zak-com-juwel'
      ) {
        quali = 'Juweliers en handelaren in edelstenen en edelmetalen(5)';
      } else if (
        user.sector === 'kunst-handel'
        || user.sector === 'handel-kunsthandel'
        || user.sector === 'handel-veiling'
        || user.sector === 'zak-com-veiling'
      ) {
        quali = 'Kunsthandelaren, veilinghuizen(8)';
      } else if (
        user.sector === 'handel-militair'
        || user.sector === 'zak-com-militair'
      ) {
        quali = 'Wapenhandel(12)';
      } else if (
        user.sector === 'ict-gamen-gokken'
        || user.branche === 'gok'
      ) {
        quali = 'Kansspelen en gaming al dan niet online (casino, speelhallen, poker, etc.)(6)';
      } else if (
        user.sector === 'ict-p2p'
      ) {
        quali = 'Digitale peer-to-peer marketplaces (vergelijkbaar met Uber, Ebay, Airbnb, bol.com, Marktplaats)(3)';
      } else if (
        user.branche === 'horeca'
        || user.branche === 'zorg'
        || user.branche === 'cash'
        || user.sector === 'zak-com-shop'
      ) {
        quali = 'Cash-intensieve retail business (horeca, zonnebanksalons, persoonlijke verzorging, massagesalons, bloemenhandelaren, belwinkels, pandjeshuizen, etc.)(1)';
      } else if (user.sector === 'vastgoed') {
        quali = 'Vastgoedexploitatie en –ontwikkeling (in binnen- en/of buitenland)(1)';
      } else if (user.branche === 'char') {
        quali = 'Charitatieve instellingen of stichtingen(2)';
      } else if (user.branche === 'kerk') {
        quali = 'Kerkgenootschappen en andere religieuze instellingen(7)';
      }
      return quali;
    },
    selectedBranche(persoon) {
      return find(this.brancheList, { code: persoon.branche })
        ? find(this.brancheList, { code: persoon.branche }).branche
        : '';
    },
    selectedSector(persoon) {
      const branche = find(this.brancheList, { code: persoon.branche });
      let selectedSector = '';
      if (branche && branche.sectors.length) {
        selectedSector = find(branche.sectors, { code: persoon.sector })
          ? find(branche.sectors, { code: persoon.sector }).name
          : '';
      }
      return selectedSector;
    },
    fromSatProfile(value) {
      let profile;
      if (value === 'DB6') {
        profile = 'Doelbeleggen E';
      } else if (value === 'DB5') {
        profile = 'Doelbeleggen D';
      } else if (value === 'DB4') {
        profile = 'Doelbeleggen C';
      } else if (value === 'DB3') {
        profile = 'Doelbeleggen B';
      } else if (value === 'DB2') {
        profile = 'Doelbeleggen A';
      } else if (value === 'DB1') {
        profile = 'Doelbeleggen Sparen';
      } else {
        profile = '';
      }
      return profile;
    },
    toSatProfile(value) {
      let profile;
      if (value === 'geen') {
        profile = 'DB1';
      } else if (value === 'zeer laag') {
        profile = 'DB2';
      } else if (value === 'laag') {
        profile = 'DB3';
      } else if (value === 'gemiddeld') {
        profile = 'DB4';
      } else if (value === 'hoog') {
        profile = 'DB5';
      } else if (value === 'zeer hoog') {
        profile = 'DB6';
      } else if (value === 'extreem hoog') {
        profile = 'DB6';
      } else {
        profile = 'DB6';
      }
      return profile;
    },
    toSatProfile2(value) {
      let profile;
      if (value === 'Doelbeleggen Sparen') {
        profile = 'DB1';
      } else if (value === 'Doelbeleggen A') {
        profile = 'DB2';
      } else if (value === 'Doelbeleggen B') {
        profile = 'DB3';
      } else if (value === 'Doelbeleggen C') {
        profile = 'DB4';
      } else if (value === 'Doelbeleggen D') {
        profile = 'DB5';
      } else if (value === 'Doelbeleggen E') {
        profile = 'DB6';
      } else {
        profile = 'DB6';
      }
      return profile;
    },
    addPerson() {
      if (this.intake.rekeningData.type === 'Bedrijfsrekening') {
        this.intake.rekeningData.step = this.intake.persoonsData.push({ type: '' });
        this.intake.rekeningData.step = this.intake.persoonsData.length - 1;
      } else if (this.intake.rekeningData.type === 'Particuliere rekening') {
        if (
          this.intake.goalData.box !== '1'
        ) {
          this.intake.rekeningData.step = this.intake.persoonsData.push({ type: 'Rekeninghouder' });
          this.intake.rekeningData.step = this.intake.persoonsData.length - 1;
        } else {
          this.intake.rekeningData.step = this.intake.persoonsData.push({ type: '' });
          this.intake.rekeningData.step = this.intake.persoonsData.length - 1;
        }
      } else {
        // Minderjarige
        this.intake.rekeningData.step = this.intake.persoonsData.push({ type: 'Volmacht' });
        this.intake.rekeningData.step = this.intake.persoonsData.length - 1;
      }
      this.storeIntake(2, this.intake.rekeningData.step);
      this.intake.step = 2;
    },
    checkAssetOrigin(personData) {
      const herkomstVermogenArray = [];
      if (personData.herkomstVermogenSalaris === 'Yes') {
        herkomstVermogenArray.push('Sparen / beleggen uit salaris');
      }
      if (personData.herkomstVermogenErfenis === 'Yes') {
        herkomstVermogenArray.push('Erfenis');
      }
      if (personData.herkomstVermogenSchenking === 'Yes') {
        herkomstVermogenArray.push('Schenking');
      }
      if (personData.herkomstVermogenWoningverkoop === 'Yes') {
        herkomstVermogenArray.push('Woningverkoop');
      }
      if (personData.herkomstVermogenBedrijfsverkoop === 'Yes') {
        herkomstVermogenArray.push('Bedrijfsverkoop');
      }
      if (personData.herkomstVermogenBox1lijfrente === 'Yes') {
        herkomstVermogenArray.push('Box 1-lijfrente');
      }
      if (personData.herkomstVermogenBox3lijfrente === 'Yes') {
        herkomstVermogenArray.push('Box 3-polis');
      }
      if (personData.herkomstVermogenGoudenhanddruk === 'Yes') {
        herkomstVermogenArray.push('Gouden handdruk');
      }
      if (personData.herkomstVermogenCryptovaluta === 'Yes') {
        herkomstVermogenArray.push('Cryptovaluta');
      }
      if (personData.herkomstVermogenAnders === 'Yes') {
        herkomstVermogenArray.push(`Anders (${personData.herkomstVermogenOmschrijving})`);
      }
      return herkomstVermogenArray.join(', ');
    },
    checkExperienceInput(value) {
      const experienceInputArray = [];
      if (value.ervaringVermogensbeheer === 'Yes') {
        experienceInputArray.push('ervaringVermogensbeheer');
      }
      if (value.ervaringBeleggingsadvies === 'Yes') {
        experienceInputArray.push('ervaringBeleggingsadvies');
      }
      if (value.ervaringOrderexecutie === 'Yes') {
        experienceInputArray.push('ervaringOrderexecutie');
      }
      return experienceInputArray.join(', ');
    },
    checkIban(iban) {
      let sum = String(iban);
      sum = sum.replace(/ /gi, '');
      sum = sum.replace(' ', '');
      if (sum.length < 15) {
        return false;
      }

      sum = sum.slice(4) + sum.slice(0, 4);
      const letters = {
        a: 10,
        b: 11,
        c: 12,
        d: 13,
        e: 14,
        f: 15,
        g: 16,
        h: 17,
        i: 18,
        j: 19,
        k: 20,
        l: 21,
        m: 22,
        n: 23,
        o: 24,
        p: 25,
        q: 26,
        r: 27,
        s: 28,
        t: 29,
        u: 30,
        v: 31,
        w: 32,
        x: 33,
        y: 34,
        z: 35,
      };
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(letters)) {
        sum = sum.replace(new RegExp(key, 'gi'), value);
      }

      // eslint-disable-next-line
      function iso7064Mod97_10(iban) {
        let remainder = iban;
        let block;

        while (remainder.length > 2) {
          block = remainder.slice(0, 9);
          remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
        }
        return parseInt(remainder, 10) % 97;
      }

      sum = iso7064Mod97_10(sum);
      return sum === 1;
    },
    financeFilter(o) {
      if (
        this.intake.rekeningData.type === 'Minderjarige rekening'
        && o.type !== 'Minderjarige'
      ) {
        return true;
      }
      if (
        this.intake.rekeningData.type === 'Particuliere rekening'
        && o.type !== 'Volmacht'
      ) {
        return true;
      }
      if (
        this.intake.rekeningData.type === 'Bedrijfsrekening'
        && o.type !== 'Volmacht'
      ) {
        return true;
      }
      return false;
    },
    deathFilter(o) {
      return !o.sterfteDatum;
    },
    redoIntake() {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u een herintake wilt starten?',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.redoIntake(this.port, (previousResponse) => {
              window.location.href = `?intake=${previousResponse.data.intake}`;
            });
          }
        },
      });
    },
    stopIntake() {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u deze herintake wilt verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteIntake(this.getQueryVariable('intake'), () => {
              window.onbeforeunload = () => {};
              window.location.href = '?';
            });
          }
        },
      });
    },
    setDefaults() {
      const g = this.intake.goalData.type;
      if (this.intakeAdmin.beleggen.brand === 'Doelbeleggen') {
        if (g === 'studiekinderen') {
          this.intake.goalData.leeftijdKind = '3';
          this.intake.goalData.leeftijdKindTot = '18';
          this.intake.goalData.looptijd = '15';
          this.intake.goalData.doel = '50000';
          this.intake.goalData.vermogen = '7500';
          this.intake.goalData.stortingenBedrag = '150';
        } else if (g === 'pensioen'
          || g === 'gouden-handdruk-opbouwend'
          || g === 'netto-lijfrente-opbouwend') {
          this.intake.goalData.leeftijd = '50';
          this.intake.goalData.looptijd = '27';
          this.intake.goalData.pensioenLeeftijd = '67';
          this.intake.goalData.uitkeringsPeriode = '20';
          this.intake.goalData.doel = '240000';
          this.intake.goalData.vermogen = '50000';
          this.intake.goalData.stortingenBedrag = g !== 'gouden-handdruk-opbouwend' ? '175' : '0';
          this.intake.goalData.doelAanvulling = '1000';
        } else if (g === 'levensonderhoud'
          || g === 'gouden-handdruk-uitkerend'
          || g === 'netto-lijfrente-uitkerend') {
          this.intake.goalData.looptijd = '20';
          this.intake.goalData.doel = '0';
          this.intake.goalData.vermogen = '175000';
          this.intake.goalData.stortingenBedrag = '0';
          this.intake.goalData.doelAanvulling = '1000';
        } else if (g === 'hypotheek') {
          this.intake.goalData.looptijd = '20';
          this.intake.goalData.doel = '220000';
          this.intake.goalData.vermogen = '50000';
          this.intake.goalData.stortingenBedrag = '350';
        } else {
          this.intake.goalData.looptijd = '10';
          this.intake.goalData.doel = '45000';
          this.intake.goalData.vermogen = '20000';
          this.intake.goalData.stortingenBedrag = '150';
          this.intake.goalData.extrarendement = '20';
          this.intake.goalData.inflatie = 'Yes';
          this.intake.goalData.vermogensbelasting = 'Yes';
        }
        this.intakeAdmin.beleggen.report = '1';
      }
    },
    deletePerson(index) {
      this.$store.state.confirm.toggle({
        text: 'Persoon verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deletePerson(this.getQueryVariable('intake'), index, () => {
              window.location.reload();
            });
          }
        },
      });
    },
    validationAlert() {
      if (this.errors > 0) {
        this.$store.state.confirm.toggle({
          alert: true,
          text: 'Nog niet alle velden op deze pagina zijn ingevuld',
          cb: () => {},
        });
      }
    },
    validationModal() {
      if (
        this.errors < 1
      ) {
        if (!this.redo) {
          this.storeIntake(this.menu[this.activeMenu + 1].id, this.menu[this.activeMenu + 1].subId);
        } else {
          this.storeIntake(6);
        }
      } else {
        this.$store.state.intakeValidate = true;
        this.$store.state.confirm.toggle({
          text: 'Nog niet alle velden op deze pagina zijn ingevuld, weet u zeker dat u wilt doorgaan?',
          cb: (confirmed) => {
            if (confirmed) {
              if (!this.redo) {
                this.storeIntake(
                  this.menu[this.activeMenu + 1].id,
                  this.menu[this.activeMenu + 1].subId,
                );
              } else {
                this.storeIntake(6);
              }
            }
          },
        });
      }
    },
    toggle() {
      if (!window.matchMedia('(min-width: 800px)').matches && document.getElementById('sidemenu')) {
        if (document.getElementById('sidebar').style.display !== 'block') {
          document.getElementById('sidebar').style.display = 'block';
        } else {
          document.getElementById('sidebar').style.display = 'none';
        }
      }
    },
    quitIntake() {
      this.storeIntake(this.intake.step === 5 ? 2 : this.intake.step, '0', true);
    },
    resetType() {
      this.intake.rekeningData.step = null;
      this.intake.rekeningData.type = null;
      this.intake.step = 2;
    },
    storeIntake(newStep = 6, subId = null, quit = false, refresh = false, cb = null) {
      if (!this.redo) {
        this.$store.state.intakeValidate = false;
      }
      this.$parent.$refs.main.scrollTo(0, 0);
      this.intake.step = null;
      this.intake.step = newStep;
      this.intake.totalFields = this.totalFields;
      this.intake.wrongFields = this.wrongFields;
      this.intake.files = `${this.files.length}`;

      if (newStep === 2) {
        if (this.intake.rekeningData.type !== null) {
          this.intake.rekeningData.step = subId;
        }
      } else if (newStep === 5) {
        this.intake.financeData.step = subId;
      }
      // stortingen & onttrekkingen
      if (this.intakeAdmin.beleggen.brand === 'Doelbeleggen') {
        if (Number(this.intake.goalData.stortingenBedrag) !== 0
        && this.intake.goalData.type !== 'gouden-handdruk-opbouwend') {
          this.intake.goalData.stortingen = 'Yes';
        } else {
          this.intake.goalData.stortingen = 'No';
        }
      }
      if (this.intake.goalData.stortingen !== 'Yes') {
        this.intake.goalData.stortingenBedrag = '0';
      }
      if (this.intake.goalData.onttrekkingen !== 'Yes') {
        this.intake.goalData.onttrekkingenBedrag = '0';
      }
      if (
        Number(this.intake.goalData.stortingenBedrag) <= 0
        || Number(this.intake.goalData.onttrekkingenBedrag) > 0
      ) {
        this.intake.goalData.collect = 'No';
      }
      // Check if risk is changed or accountNr is changed to set priority in list of redos
      if (this.redo && this.intake.goalData.risk !== this.previousIntake.goalData.risk) {
        this.intake.goalData.riskChanged = true;
      } else {
        this.intake.goalData.riskChanged = false;
      }
      if (this.redo && this.intake.rekeningData.iban.toUpperCase().replace(/\s/g, '')
          !== this.previousIntake.rekeningData.iban.toUpperCase().replace(/\s/g, '')) {
        this.intake.goalData.vtrChanged = true;
      } else {
        this.intake.goalData.vtrChanged = false;
      }

      if (this.redo
        && this.previousIntakeAdmin.cdd
        && this.previousIntakeAdmin.cdd['0-riskassesment']
        && this.previousIntakeAdmin.cdd['0-riskassesment'].answer) {
        this.intakeAdmin.oldRiskAnswer = this.previousIntakeAdmin.cdd['0-riskassesment'].answer;
      }
      // experience
      if (this.intake.experienceData.ervaring !== 'Yes') {
        delete this.intake.experienceData.ervaringVermogensbeheer;
        delete this.intake.experienceData.ervaringBeleggingsadvies;
        delete this.intake.experienceData.ervaringOrderexecutie;

        delete this.intake.experienceData.ervaringAandelen;
        delete this.intake.experienceData.ervaringTrackers;
        delete this.intake.experienceData.ervaringObligaties;
        delete this.intake.experienceData.ervaringOpties;
      }
      // check has financeData
      if (this.intake.rekeningData.type !== 'Bedrijfsrekening') {
        this.intake.bedrijfsData = {};
      }
      for (let i = 0; i < this.intake.persoonsData.length; i += 1) {
        if (this.intake.persoonsData[i].voornaam && !this.intake.persoonsData[i].roepnaam) {
          this.intake.persoonsData[i].roepnaam = this.intake.persoonsData[i].voornaam;
        }
        if (
          (this.intake.rekeningData.type === 'Minderjarige rekening' && this.intake.persoonsData[i].type !== 'Volmacht') || (this.intake.rekeningData.type !== 'Minderjarige rekening' && this.intake.persoonsData[i].type === 'Volmacht')
        ) {
          // clear all finance
          delete this.intake.persoonsData[i].jaarinkomen;
          delete this.intake.persoonsData[i].pensioen;
          delete this.intake.persoonsData[i].pensioenAanvullend;
          delete this.intake.persoonsData[i].anderInkomen;
          delete this.intake.persoonsData[i].levensonderhoud;
          delete this.intake.persoonsData[i].spaarrekening;
          delete this.intake.persoonsData[i].beleggingen;
          delete this.intake.persoonsData[i].eigenwoning;
          delete this.intake.persoonsData[i].huurlasten;
          delete this.intake.persoonsData[i].geenWoningGeenHuurlasten;
          delete this.intake.persoonsData[i].onroerendgoed;
          delete this.intake.persoonsData[i].schulden;
        }
        if (
          this.financeFilter(this.intake.persoonsData[i])
          && this.intake.goalData.type === 'pensioen'
          && this.intake.persoonsData[i].geboorteDatum
          && !this.intake.goalData.targetDate
        ) {
          const born = new Date(this.intake.persoonsData[i].geboorteDatum);
          born.setFullYear(
            born.getFullYear() + Number(this.intake.goalData.pensioenLeeftijd),
          );
          // eslint-disable-next-line
          this.intake.goalData.targetDate = born.toISOString().split('T')[0];
        }
        if (
          this.intake.persoonsData[i].type === 'Minderjarige'
          && this.intake.goalData.type === 'studiekinderen'
          && this.intake.persoonsData[i].geboorteDatum
          && !this.intake.goalData.targetDate
        ) {
          const born = new Date(this.intake.persoonsData[i].geboorteDatum);
          born.setFullYear(
            born.getFullYear() + Number(this.intake.goalData.leeftijdKindTot),
          );
          // eslint-disable-next-line
          this.intake.goalData.targetDate = born.toISOString().split('T')[0];
        }
        // clear based on closed
        if (this.intake.persoonsData[i].anderInkomen !== 'Yes') {
          delete this.intake.persoonsData[i].anderInkomenPerJaar;
        }
        if (this.intake.persoonsData[i].levensonderhoud !== 'ja, en kan sparen') {
          delete this.intake.persoonsData[i].kanSparenBedrag;
        }
        if (this.intake.persoonsData[i].inkomenType === 'Pensioen' || this.intake.persoonsData[i].inkomenType === 'Geen') {
          delete this.intake.persoonsData[i].jaarinkomen;
        }
        if (this.intake.persoonsData[i].inkomenType === 'Anders') {
          delete this.intake.persoonsData[i].bedrijf;
        }
        // spaarrekeningen
        if (this.intake.persoonsData[i].spaarrekening !== 'Yes') {
          delete this.intake.persoonsData[i].spaarrekeningBedrag;
          delete this.intake.persoonsData[i].spaarrekening2;
        }
        if (this.intake.persoonsData[i].spaarrekening2 !== 'Yes') {
          delete this.intake.persoonsData[i].spaarrekeningBedrag2;
          delete this.intake.persoonsData[i].spaarrekening3;
        }
        if (this.intake.persoonsData[i].spaarrekening3 !== 'Yes') {
          delete this.intake.persoonsData[i].spaarrekeningBedrag3;
        }
        // beleggingen
        if (this.intake.persoonsData[i].beleggingen !== 'Yes') {
          delete this.intake.persoonsData[i].beleggingenBedrag;
          if (this.intake.persoonsData[i].beleggingenInstantie === 'Anders') {
            delete this.intake.persoonsData[i].beleggingenInstantieOmschrijving;
          }
          delete this.intake.persoonsData[i].beleggingenInstantie;
          delete this.intake.persoonsData[i].beleggingenTypeDienst;
          delete this.intake.persoonsData[i].beleggingenProfiel;
          delete this.intake.persoonsData[i].beleggingenMeer;
        }
        if (this.intake.persoonsData[i].beleggingenMeer !== 'Yes') {
          delete this.intake.persoonsData[i].beleggingenMeerBedrag;
          if (this.intake.persoonsData[i].beleggingenMeerInstantie === 'Anders') {
            delete this.intake.persoonsData[i].beleggingenMeerInstantieOmschrijving;
          }
          delete this.intake.persoonsData[i].beleggingenMeerInstantie;
          delete this.intake.persoonsData[i].beleggingenMeerTypeDienst;
          delete this.intake.persoonsData[i].beleggingenMeerProfiel;
          delete this.intake.persoonsData[i].beleggingenNogMeer;
        }
        if (this.intake.persoonsData[i].beleggingenNogMeer !== 'Yes') {
          delete this.intake.persoonsData[i].beleggingenNogMeerBedrag;
          if (this.intake.persoonsData[i].beleggingenNogMeerInstantie === 'Anders') {
            delete this.intake.persoonsData[i].beleggingenNogMeerInstantieOmschrijving;
          }
          delete this.intake.persoonsData[i].beleggingenNogMeerInstantie;
          delete this.intake.persoonsData[i].beleggingenNogMeerTypeDienst;
          delete this.intake.persoonsData[i].beleggingenNogMeerProfiel;
        }
        // huur
        if (this.intake.persoonsData[i].huur !== 'Yes') {
          delete this.intake.persoonsData[i].huurlasten;
        } else {
          delete this.intake.persoonsData[i].geenWoningGeenHuurlasten;
        }
        // hypotheek
        if (this.intake.persoonsData[i].eigenwoning !== 'Yes') {
          delete this.intake.persoonsData[i].eigenwoningVrijeverkoopwaarde;
          delete this.intake.persoonsData[i].hypotheekEigenWoning;
        }
        if (this.intake.persoonsData[i].hypotheekEigenWoning !== 'Yes') {
          delete this.intake.persoonsData[i].hypotheekEigenWoning2;
          delete this.intake.persoonsData[i].hypotheekEigenWoningWaarde;
        }
        if (this.intake.persoonsData[i].hypotheekEigenWoning2 !== 'Yes') {
          delete this.intake.persoonsData[i].hypotheekEigenWoning3;
          delete this.intake.persoonsData[i].hypotheekEigenWoning2Waarde;
        }
        if (this.intake.persoonsData[i].hypotheekEigenWoning3 !== 'Yes') {
          delete this.intake.persoonsData[i].hypotheekEigenWoning3Waarde;
        }
        // onroerend goed
        if (this.intake.persoonsData[i].onroerendgoed !== 'Yes') {
          delete this.intake.persoonsData[i].onroerendgoedVrijeverkoopwaarde;
          delete this.intake.persoonsData[i].hypotheekOnroerendGoed;
        }
        if (this.intake.persoonsData[i].hypotheekOnroerendGoed !== 'Yes') {
          delete this.intake.persoonsData[i].hypotheekOnroerendGoed2;
          delete this.intake.persoonsData[i].hypotheekOnroerendGoedWaarde;
        }
        if (this.intake.persoonsData[i].hypotheekOnroerendGoed2 !== 'Yes') {
          delete this.intake.persoonsData[i].hypotheekOnroerendGoed3;
          delete this.intake.persoonsData[i].hypotheekOnroerendGoed2Waarde;
        }
        if (this.intake.persoonsData[i].hypotheekOnroerendGoed3 !== 'Yes') {
          delete this.intake.persoonsData[i].hypotheekOnroerendGoed3Waarde;
        }
        // schulden
        if (this.intake.persoonsData[i].schulden !== 'Yes') {
          delete this.intake.persoonsData[i].schulden2;
          delete this.intake.persoonsData[i].schuldenBedrag;
          delete this.intake.persoonsData[i].schuldenMaandelijks;
        }
        if (this.intake.persoonsData[i].schuldenMeer !== 'Yes') {
          delete this.intake.persoonsData[i].schuldenMeer2;
          delete this.intake.persoonsData[i].schuldenMeerBedrag;
          delete this.intake.persoonsData[i].schuldenMeerMaandelijks;
        }
        if (this.intake.persoonsData[i].schuldenMeer2 !== 'Yes') {
          delete this.intake.persoonsData[i].schuldenMeer3;
          delete this.intake.persoonsData[i].schuldenMeer2Bedrag;
          delete this.intake.persoonsData[i].schuldenMeer2Maandelijks;
        }
        if (this.intake.persoonsData[i].schuldenMeer3 !== 'Yes') {
          delete this.intake.persoonsData[i].schuldenMeer3Bedrag;
          delete this.intake.persoonsData[i].schuldenMeer3Maandelijks;
        }
      }

      if (
        (this.intakeAdmin.beleggen.brand === 'VMVB' || this.intakeAdmin.beleggen.brand === 'BVS')
        && this.intake.rekeningData.type === 'Bedrijfsrekening'
      ) {
        // spaarrekeningen
        if (this.intake.financeData.spaarrekening !== 'Yes') {
          delete this.intake.financeData.spaarrekeningBedrag;
          delete this.intake.financeData.spaarrekeningInstantie;
          if (this.intake.financeData.spaarrekeningInstantieOmschrijving) {
            delete this.intake.financeData.spaarrekeningInstantieOmschrijving;
          }
          delete this.intake.financeData.spaarrekening2;
        }
        if (this.intake.financeData.spaarrekening2 !== 'Yes') {
          delete this.intake.financeData.spaarrekening2Bedrag;
          delete this.intake.financeData.spaarrekening2Instantie;
          if (this.intake.financeData.spaarrekening2InstantieOmschrijving) {
            delete this.intake.financeData.spaarrekening2InstantieOmschrijving;
          }
          delete this.intake.financeData.spaarrekening3;
        }
        if (this.intake.financeData.spaarrekening3 !== 'Yes') {
          delete this.intake.financeData.spaarrekening3Bedrag;
          delete this.intake.financeData.spaarrekening3Instantie;
          if (this.intake.financeData.spaarrekening3InstantieOmschrijving) {
            delete this.intake.financeData.spaarrekening3InstantieOmschrijving;
          }
        }
        // beleggingen
        if (this.intake.financeData.beleggingen !== 'Yes') {
          delete this.intake.financeData.beleggingenBedrag;
          if (this.intake.financeData.beleggingenInstantieOmschrijving) {
            delete this.intake.financeData.beleggingenInstantieOmschrijving;
          }
          delete this.intake.financeData.beleggingenInstantie;
          delete this.intake.financeData.beleggingenTypeDienst;
          delete this.intake.financeData.beleggingenProfiel;
          delete this.intake.financeData.beleggingenMeer;
        }
        if (this.intake.financeData.beleggingenMeer !== 'Yes') {
          delete this.intake.financeData.beleggingenMeerBedrag;
          if (this.intake.financeData.beleggingenMeerInstantieOmschrijving) {
            delete this.intake.financeData.beleggingenMeerInstantieOmschrijving;
          }
          delete this.intake.financeData.beleggingenMeerInstantie;
          delete this.intake.financeData.beleggingenMeerTypeDienst;
          delete this.intake.financeData.beleggingenMeerProfiel;
          delete this.intake.financeData.beleggingenNogMeer;
        }
        if (this.intake.financeData.beleggingenNogMeer !== 'Yes') {
          delete this.intake.financeData.beleggingenNogMeerBedrag;
          if (this.intake.financeData.beleggingenNogMeerInstantieOmschrijving) {
            delete this.intake.financeData.beleggingenNogMeerInstantieOmschrijving;
          }
          delete this.intake.financeData.beleggingenNogMeerInstantie;
          delete this.intake.financeData.beleggingenNogMeerTypeDienst;
          delete this.intake.financeData.beleggingenNogMeerProfiel;
        }
        // vastgoed
        if (this.intake.financeData.onroerendgoed !== 'Yes') {
          delete this.intake.financeData.onroerendgoedCommercieel;
          delete this.intake.financeData.onroerendgoedVrijeverkoopwaarde;
          if (this.intake.financeData.onroerendgoedBedragPerJaar) {
            delete this.intake.financeData.onroerendgoedBedragPerJaar;
          }

          if (this.intake.financeData.overigOnroerendgoed !== 'Yes') {
            delete this.intake.financeData.overigOnroerendgoedObjecten;
            delete this.intake.financeData.overigOnroerendgoedCommercieel;
            delete this.intake.financeData.overigOnroerendgoedVrijeverkoopwaarde;
            if (this.intake.financeData.overigOnroerendgoedCommercieelObjecten) {
              delete this.intake.financeData.overigOnroerendgoedCommercieelObjecten;
              delete this.intake.financeData.overigOnroerendgoedBedragPerJaar;
            }
          }
          // hypotheek
          if (this.intake.financeData.hypotheekVastgoed !== 'Yes') {
            delete this.intake.financeData.hypotheekVastgoed2;
            delete this.intake.financeData.hypotheekVastgoedType;
            delete this.intake.financeData.hypotheekVastgoedWaarde;
            delete this.intake.financeData.hypotheekVastgoedInstantie;
            if (this.intake.financeData.hypotheekVastgoedInstantieOmschrijving) {
              delete this.intake.financeData.hypotheekVastgoedInstantieOmschrijving;
            }
            delete this.intake.financeData.hypotheekVastgoedRenteType;
            if (this.intake.financeData.hypotheekVastgoedRente) {
              delete this.intake.financeData.hypotheekVastgoedRente;
              delete this.intake.financeData.hypotheekVastgoedLooptijd;
            }
          }
          if (this.intake.financeData.hypotheekVastgoed2 !== 'Yes') {
            delete this.intake.financeData.hypotheekVastgoed3;
            delete this.intake.financeData.hypotheekVastgoed2Type;
            delete this.intake.financeData.hypotheekVastgoed2Waarde;
            delete this.intake.financeData.hypotheekVastgoed2Instantie;
            if (this.intake.financeData.hypotheekVastgoed2InstantieOmschrijving) {
              delete this.intake.financeData.hypotheekVastgoed2InstantieOmschrijving;
            }
            delete this.intake.financeData.hypotheekVastgoed2RenteType;
            if (this.intake.financeData.hypotheekVastgoed2Rente) {
              delete this.intake.financeData.hypotheekVastgoed2Rente;
              delete this.intake.financeData.hypotheekVastgoed2Looptijd;
            }
          }
          if (this.intake.financeData.hypotheekVastgoed3 !== 'Yes') {
            delete this.intake.financeData.hypotheekVastgoed3Type;
            delete this.intake.financeData.hypotheekVastgoed3Waarde;
            delete this.intake.financeData.hypotheekVastgoed3Instantie;
            if (this.intake.financeData.hypotheekVastgoed3InstantieOmschrijving) {
              delete this.intake.financeData.hypotheekVastgoed3InstantieOmschrijving;
            }
            delete this.intake.financeData.hypotheekVastgoed3RenteType;
            if (this.intake.financeData.hypotheekVastgoed3Rente) {
              delete this.intake.financeData.hypotheekVastgoed3Rente;
              delete this.intake.financeData.hypotheekVastgoed3Looptijd;
            }
          }
        }
      }
      if (this.writeModus) {
        this.sdk.updateIntake(this.getQueryVariable('intake'), JSON.stringify(this.intake), () => {
          if (quit) {
            window.onbeforeunload = () => {};
            window.location.href = '?';
          }
          if (refresh) {
            window.onbeforeunload = () => {};
            window.location.href = `?${
              this.getQueryVariable('intake') ? `intake=${this.getQueryVariable('intake')}` : ''
            }`;
          }
          if (typeof cb === 'function') {
            cb();
          }
        });
      } else {
        if (quit) {
          window.onbeforeunload = () => {};
          window.location.href = '?';
        }
        if (refresh) {
          window.onbeforeunload = () => {};
          window.location.href = `?${this.getQueryVariable('intake') ? `intake=${this.getQueryVariable('intake')}` : ''}`;
        }
      }
      if (window.history.state.step !== newStep || window.history.state.subStep !== subId) {
        window.history.pushState({
          step: newStep,
          subStep: subId,
        }, 'step');
      }
    },
    acceptIntake() {
      if (this.redo) {
        this.completeIntake();
      } else if (this.port) {
        this.sdk.adminIntake(this.getQueryVariable('intake'), JSON.stringify(this.intakeAdmin), () => {
          this.sdk.acceptIntake(this.getQueryVariable('intake'), () => {
            window.onbeforeunload = () => {};
            window.location.reload();
          });
        });
      } else {
        // eslint-disable-next-line
        alert('U kunt een intake alleen goedkeuren wanneer er een portefeuillenummer is aangewezen.');
      }
    },
    returnIntake() {
      this.sdk.returnIntake(this.getQueryVariable('intake'), () => {
        window.onbeforeunload = () => {};
        window.location.reload();
      });
    },
    signIntake() {
      this.signing = true;
      const utmCookieRaw = this.readCookie('utmcookie');
      if (utmCookieRaw) {
        const utmCookieParts = JSON.parse(utmCookieRaw);
        if (utmCookieParts && utmCookieParts.utm_source === 'finner.nl') {
          // ajax call 514484
          axios.post(`https://api.finner.nl/api/conversion/Completed?transactionIDs=${utmCookieParts.fid}&product=514484-2`).then(() => {});
        }
      }
      this.sdk.signIntake(this.getQueryVariable('intake'), null, () => {
        setTimeout(() => {
          window.onbeforeunload = () => {};
          window.location.reload();
        }, 5000);
      });
    },
    signDocumentsCheck() {
      this.sdk.signDocumentsCheck(this.getQueryVariable('intake'), () => {
        window.onbeforeunload = () => {};
        window.location.reload();
      });
    },
    completeIntake(message = true) {
      this.sdk.completeIntake(this.getQueryVariable('intake'), () => {
        window.onbeforeunload = () => {};
        window.location.href = '?';
      }, message);
    },
    storeAdmin() {
      this.intakeAdmin.errors = this.$store.state.errors;
      this.intakeAdmin.cdd = this.$store.state.cdd;
      this.intakeAdmin.showstoppers = this.$store.state.showstoppers;
      this.intakeAdmin.showstoppersErrors = this.checkPlanErrors('ss');
      this.intakeAdmin.blockersErrors = this.checkPlanErrors('b');
      this.sdk.adminIntake(this.getQueryVariable('intake'), JSON.stringify(this.intakeAdmin));
    },
    sendIntake() {
      if (this.role > 7
        && this.intake.persoonsData.length === 1
        && this.intake.persoonsData[0].sterfteDatum
      ) {
        this.$store.state.confirm.toggle({
          text: `
            De U persoon is overleden. De tenaamstelling moet gewijzigd worden naar 'Erven van'.
            <br /><br />
            Is dit aangepast?
          `,
          title: 'Let op',
          confirmText: 'Ja',
          cb: (confirmed) => {
            if (confirmed) {
              this.continueSendIntake();
            }
          },
        });
      } else if (
        Number(this.role) === 2
        && (this.intake.atpData && !this.intake.atpData.connected)
      ) {
        // Notice atp not connected
        this.$store.state.confirm.toggle({
          alert: true,
          confirmText: 'Open klantkoppeling',
          text: `Om de intake aan te kunnen vragen, dient u een klant te koppelen aan de
            vragenlijst.
          `,
          cb: this.goToClientConnect,
        });
      } else if (this.intake.atpData && this.intake.atpData.connected) {
        if (this.role > 7) {
          this.sdk.getOwnerMandates(this.client, (response) => {
            if (response.status === 200) {
              const mandates = filter(
                response.data,
                (o) => o.advisor === Number(this.intakeAdmin.beleggen.sales),
              );
              if (!mandates[0]) {
                // No advisor, but intake is connected to ATP
                this.$store.state.confirm.toggle({
                  alert: true,
                  text: 'Deze vragenlijst kan niet worden ingeleverd. Klant heeft de machtiging van de gekoppelde adviseur verwijderd.',
                  cb: () => {},
                });
              } else if (!mandates[0].accepted) {
                // Advisor available, but mandate not accepted
                this.$store.state.confirm.toggle({
                  text: 'Klant dient eerst de mandaat te accepteren of te weigeren.',
                  title: 'Mandaat accepteren/weigeren',
                  alert: true,
                  confirmText: 'Terug',
                  cb: () => {},
                });
              } else {
                this.continueSendIntake();
              }
            }
          });
        } else {
          const mandates = filter(
            this.$store.state.mandates,
            (o) => o.advisor === Number(this.intakeAdmin.beleggen.sales),
          );
          if (!mandates[0]) {
            // No advisor, but intake is connected to ATP
            this.$store.state.confirm.toggle({
              alert: true,
              text: 'Deze vragenlijst kan niet worden ingeleverd. U heeft de machtiging van de gekoppelde adviseur verwijderd.',
              cb: () => {},
            });
          } else if (!mandates[0].accepted) {
            // Advisor available, but mandate not accepted
            this.$store.state.confirm.toggle({
              text: `U heeft uw machtiging voor de adviseur nog niet geaccepteerd.
                <br><br>Om uw rekeningaanvraag in te dienen dient u dit verzoek eerst te accepteren.
                <br><br>Met deze machtiging heeft uw adviseur inzage in uw dossier.
                <span v-if="this.style == 'db'">
                  U kunt de voorwaarden
                  <a
                    href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-online-machtiging-adviseur.pdf"
                    target="_blank"
                  >
                    <b>hier</b>
                  </a> nalezen.
                </span>
                <br><br>Let op, bij weigeren verwijdert u ook de vragenlijst.`,
              title: 'Machtiging adviseur',
              confirmText: 'Accepteren',
              cancelText: 'Weigeren',
              cb: (confirmed) => {
                if (confirmed) {
                  this.sdk.acceptMandate(this.intakeAdmin.beleggen.sales, (accResponse) => {
                    if (accResponse.status === 200) {
                      this.continueSendIntake();
                    }
                  });
                } else {
                  this.sdk.removeMandate(this.intakeAdmin.beleggen.sales, (remResponse) => {
                    if (remResponse.status === 200) {
                      this.quitIntake();
                    }
                  });
                }
              },
            });
          } else {
            this.continueSendIntake();
          }
        }
      } else {
        this.continueSendIntake();
      }
    },
    continueSendIntake() {
      if (Number(this.$store.state.role > 7)) {
        if ((this.intakeAdmin.beleggen.brand === 'VMVB' || this.intakeAdmin.beleggen.brand === 'BVS')
          && !this.intakeAdmin.intakeCheck) {
          this.intakeAdmin.intakeCheck = {
            handedUser: this.$store.state.name,
            handedDate: new Date(),
          };
          this.storeIntake(this.intake.step, null, false, false);
          this.storeAdmin();
          window.onbeforeunload = () => { };
          window.location.href = `?intake=${this.getQueryVariable('intake')}`;
          return;
        }
        if ((this.intakeAdmin.beleggen.brand === 'VMVB' || this.intakeAdmin.beleggen.brand === 'BVS')
          && this.intakeAdmin.intakeCheck
          && Number(this.$store.state.role) > 9) {
          this.intakeAdmin.intakeCheck.checkedUser = this.$store.state.name;
          this.intakeAdmin.intakeCheck.checkedDate = new Date();
        }
      }
      this.storeIntake(this.intake.step, null, false, false);
      this.sdk.adminIntake(this.getQueryVariable('intake'), JSON.stringify(this.intakeAdmin), () => {
        this.sdk.sendIntake(this.getQueryVariable('intake'), () => {
          const utmCookieRaw = this.readCookie('utmcookie');
          if (utmCookieRaw) {
            const utmCookieParts = JSON.parse(utmCookieRaw);
            if (utmCookieParts && utmCookieParts.utm_source === 'finner.nl') {
              // ajax call 745130
              axios.post(`https://api.finner.nl/api/conversion/Completed?transactionIDs=${utmCookieParts.fid}&product=514484-1`).then(() => {});
            }
          }
          window.onbeforeunload = () => { };
          window.location.href = `?intake=${this.getQueryVariable('intake')}`;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .step {
    text-align: center;
    padding: 10px;
    border-radius: 2px;
    color: rgba(0,0,0,0.5);
    position: relative;
    @media #{$mobile} {
      display: none;
    }
    &.active {
      color: rgba(0,0,0,1);
    }
    &:not(:first-child) {
      &::before {
        display: block;
        position: absolute;
        top: 18px;
        left: -40px;
        width: 60px;
        height: 1px;
        content: '';
        background-color: rgba(0,0,0,0.2);
      }
    }
  }
  #mobile-intakemenu-button {
    display: none;
  }
  @media screen and (max-width: 988px) {
    #mobile-intakemenu-button {
      display: block;
      float: right;
      margin: 10px;
      height: 35px;
      cursor: pointer;
    }
    .quitButton {
      margin: 20px 40px;
    }
    .card .content {
      padding: 20px;
    }
  }
  #mobile-menu {
    display: none;
    @media screen and (max-width: 988px) {
      display: block;
      position: fixed;
      background-color: $color-background;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1;
      overflow: hidden;
      padding: 0 10px;
      margin-top: -50px;
      padding-top: 50px;
    }
    select {
      float: right;
      width: auto;
      margin: 10px;
      height: 35px;
    }
    button {
      float: right;
      margin: 10px;
      height: 35px;
    }
    .logo {
      width: 35px;
      height: 35px;
      margin: 10px;
      float: left;
      &.oxby {
        width: 70px;
      }
    }
  }
</style>
